import { salesApi } from '../config/apiClient';

// ============================================
// QUICK SALE SCREEN TYPES
// ============================================

export interface QuickSaleScreenDto {
  Id: number;
  Name: string;
  BranchId?: string | null;
  ScreenType?: string; // 'Standalone' | 'Restaurant' | 'Package'
  RestaurantScreenId?: number | null; // YENİ: Restaurant ekranı ID'si
  PackageScreenId?: number | null; // YENİ: Package ekranı ID'si (Sipariş Yönetim Sistemi)
  AssignedPersonnelJson?: string | null;
  PaymentOptionsJson?: string | null;
  StockVisibilityJson?: string | null;
  PrintingSettingsJson?: string | null;
  PersonnelPermissionsJson?: string | null;
  PrepaidSystemEnabled: boolean;
  ShowProductImages: boolean;
  UseFiscalDeviceForCash: boolean;
  SelectedFiscalDevice: string; // YENİ: Yazarkasa markası
  WarnIfFiscalNotConnected: boolean; // YENİ: Yazarkasa bağlantı uyarısı
  UsePavoPayForOtherPayments: boolean;
  UseExternalPrinterForPavo: boolean;
  PavoPaymentMediatorId: number; // Kartlı ödemede Pavo ödeme aracısı (2=BKM/TechPOS, 38=AlbarakaPOS)
  UseRestP2PForPayments: boolean; // YENİ: PavoPay Rest-P2P modu ile ödeme al
  PavoRestP2PDeviceScreenCode?: string | null; // YENİ: Rest-P2P cihazının ScreenCode'u
  AllowAccountCreationOnSale: boolean;
  AllowAccountCollection: boolean; // YENİ: Cari tahsilat izni (ekran seviyesi)
  UseKitchenScreen: boolean;
  ShowScreenLayoutButton: boolean;
  SelectedQRMenuId?: string | null;
  UseCashierSystem: boolean; // YENİ: Kasiyer sistemi kullanımı
  ShowCashChangeModal: boolean; // YENİ: Para üstü modalı
  LocalServiceUrl?: string | null; // YENİ: Yerel servis URL'si (yazdırma, yazarkasa)
  AutoLockEnabled: boolean;
  AutoLockTimeoutSeconds: number;
  PredefinedDeleteReasonsJson?: string | null;
  PredefinedItemNotesJson?: string | null; // YENİ: Hazır ürün açıklamaları (JSON array)
  IsActive: boolean;
  CreatedAt: Date;
  UpdatedAt?: Date | null;
}

export interface CreateQuickSaleScreenDto {
  Name: string;
  BranchId?: string | null;
  ScreenType?: string; // YENİ: 'Standalone' veya 'Restaurant'
  AssignedPersonnelJson?: string | null;
  PaymentOptionsJson?: string | null;
  StockVisibilityJson?: string | null;
  PrintingSettingsJson?: string | null;
  PersonnelPermissionsJson?: string | null;
  PrepaidSystemEnabled?: boolean;
  ShowProductImages?: boolean;
  UseFiscalDeviceForCash?: boolean;
  SelectedFiscalDevice?: string; // YENİ: Yazarkasa markası
  WarnIfFiscalNotConnected?: boolean; // YENİ: Yazarkasa bağlantı uyarısı
  UsePavoPayForOtherPayments?: boolean;
  UseExternalPrinterForPavo?: boolean;
  PavoPaymentMediatorId?: number; // Kartlı ödemede Pavo ödeme aracısı (2=BKM/TechPOS, 38=AlbarakaPOS)
  UseRestP2PForPayments?: boolean;
  PavoRestP2PDeviceScreenCode?: string | null;
  AllowAccountCreationOnSale?: boolean;
  AllowAccountCollection?: boolean; // YENİ: Cari tahsilat izni (ekran seviyesi)
  UseKitchenScreen?: boolean;
  ShowScreenLayoutButton?: boolean;
  SelectedQRMenuId?: string | null;
  UseCashierSystem?: boolean;
  ShowCashChangeModal?: boolean;
  LocalServiceUrl?: string | null;
  AutoLockEnabled?: boolean;
  AutoLockTimeoutSeconds?: number;
  PredefinedDeleteReasonsJson?: string | null;
  PredefinedItemNotesJson?: string | null;
}

export interface UpdateQuickSaleScreenDto {
  Id: number;
  Name?: string;
  BranchId?: string | null;
  ScreenType?: string; // YENİ: 'Standalone' veya 'Restaurant' veya 'Package'
  RestaurantScreenId?: number | null; // YENİ: Restaurant ekranı ID'si
  PackageScreenId?: number | null; // YENİ: Package ekranı ID'si (Sipariş Yönetim Sistemi)
  AssignedPersonnelJson?: string | null;
  PaymentOptionsJson?: string | null;
  StockVisibilityJson?: string | null;
  PrintingSettingsJson?: string | null;
  PersonnelPermissionsJson?: string | null;
  PrepaidSystemEnabled?: boolean;
  ShowProductImages?: boolean;
  UseFiscalDeviceForCash?: boolean;
  SelectedFiscalDevice?: string; // YENİ: Yazarkasa markası
  WarnIfFiscalNotConnected?: boolean; // YENİ: Yazarkasa bağlantı uyarısı
  UsePavoPayForOtherPayments?: boolean;
  UseExternalPrinterForPavo?: boolean;
  PavoPaymentMediatorId?: number; // Kartlı ödemede Pavo ödeme aracısı (2=BKM/TechPOS, 38=AlbarakaPOS)
  UseRestP2PForPayments?: boolean;
  PavoRestP2PDeviceScreenCode?: string | null;
  AllowAccountCreationOnSale?: boolean;
  AllowAccountCollection?: boolean; // YENİ: Cari tahsilat izni (ekran seviyesi)
  UseKitchenScreen?: boolean;
  ShowScreenLayoutButton?: boolean;
  SelectedQRMenuId?: string | null;
  UseCashierSystem?: boolean;
  ShowCashChangeModal?: boolean;
  LocalServiceUrl?: string | null;
  AutoLockEnabled?: boolean;
  AutoLockTimeoutSeconds?: number;
  PredefinedDeleteReasonsJson?: string | null;
  PredefinedItemNotesJson?: string | null;
  IsActive?: boolean;
}

// ============================================
// PACKAGE SCREEN TYPES (Sipariş Yönetim Sistemi)
// ============================================

export interface PackageScreenDto {
  Id: number;
  Name: string;
  BranchId?: string | null;
  QuickSaleScreenId: number;
  DefaultDeliveryTime: number;
  AutoPrintKitchen: boolean;
  ShowCallerIdPanel: boolean;
  AutoAcceptEnabled: boolean;
  AutoAcceptDelaySeconds: number;
  AutoPrintReceiptOnAccept: boolean;
  ShowPhoneOrders: boolean;
  ShowYemekSepetiOrders: boolean;
  ShowTrendyolOrders: boolean;
  ShowGetirOrders: boolean;
  ShowMigrosOrders: boolean;
  ShowKioskOrders: boolean;
  ShowQrMenuOrders: boolean;
  ShowEcommerceOrders: boolean;
  IsActive: boolean;
  CreatedAt: string;
  UpdatedAt?: string | null;
}

export interface CreatePackageScreenDto {
  Name: string;
  BranchId?: string | null;
  QuickSaleScreenId: number;
  DefaultDeliveryTime?: number;
  AutoPrintKitchen?: boolean;
  ShowCallerIdPanel?: boolean;
  AutoAcceptEnabled?: boolean;
  AutoAcceptDelaySeconds?: number;
  AutoPrintReceiptOnAccept?: boolean;
}

export interface UpdatePackageScreenDto {
  Id: number;
  Name?: string;
  BranchId?: string | null;
  QuickSaleScreenId?: number;
  DefaultDeliveryTime?: number;
  AutoPrintKitchen?: boolean;
  ShowCallerIdPanel?: boolean;
  AutoAcceptEnabled?: boolean;
  AutoAcceptDelaySeconds?: number;
  AutoPrintReceiptOnAccept?: boolean;
  ShowPhoneOrders?: boolean;
  ShowYemekSepetiOrders?: boolean;
  ShowTrendyolOrders?: boolean;
  ShowGetirOrders?: boolean;
  ShowMigrosOrders?: boolean;
  ShowKioskOrders?: boolean;
  ShowQrMenuOrders?: boolean;
  ShowEcommerceOrders?: boolean;
  IsActive?: boolean;
}

// ============================================
// PYK SCREEN TYPES
// ============================================

export interface PykScreenDto {
  Id: number;
  Name: string;
  BranchId?: string | null;
  SettingsJson?: string | null;
  IsActive: boolean;
  CreatedAt: Date;
  UpdatedAt?: Date | null;
}

export interface CreatePykScreenDto {
  Name: string;
  BranchId?: string | null;
  SettingsJson?: string | null;
}

export interface UpdatePykScreenDto {
  Id: number;
  Name?: string;
  BranchId?: string | null;
  SettingsJson?: string | null;
  IsActive?: boolean;
}

// ============================================
// SALES SERVICE
// ============================================

/**
 * Sunucu geçici bir SQL hatası bildirdi mi? Öncelik yapısal `IsTransient` alanında;
 * API henüz güncellenmemişse EF Core'un kendi işaret cümlesine düşülür.
 */
function isTransientSqlFailure(payload: QuickSaleWithInvoiceResponse | undefined): boolean {
  if (!payload) return false;
  if (payload.IsTransient === true) return true;

  const text = `${payload.Message ?? ''} ${payload.ErrorDetails ?? ''}`;
  return /transient failure|EnableRetryOnFailure/i.test(text);
}

/** Geçici hatada tekrar denemeden önce beklenen süre (kilit sahibinin bitmesi için). */
const TRANSIENT_RETRY_DELAY_MS = 900;

/**
 * Zaman aşımı / ağ kopması sonrası "satış sunucuda kaydedildi mi?" sorgusu.
 * Tarayıcı 60 sn'de vazgeçer ama sunucunun SQL zaman aşımı 120 sn'dir: istek sunucuda
 * çoğu zaman tamamlanır. Aynı IdempotencyKey ile sunucuya sorup sonucu alırız.
 */
const IDEMPOTENCY_POLL_INTERVAL_MS = 3_000;
// Sunucu kilidi ilk istek bitene kadar ~110 sn bekletebilir; sorgu penceresi bunu kapsar.
const IDEMPOTENCY_POLL_MAX_MS = 120_000;

/** Sunucu mükerrer anahtar mesajı (eski sunucu eşzamanlı ikinci isteğe 400 döndürüyordu). */
function isAlreadySavedMessage(payload: QuickSaleWithInvoiceResponse | undefined): boolean {
  return !!payload && /zaten kaydedilmiş/i.test(payload.Message ?? '');
}

/**
 * Sunucu kilit zaman aşımı: aynı anahtarla ilk istek hâlâ kaydediliyor
 * ("Bu ödeme şu anda başka bir istekte kaydediliyor… Ödemeyi TEKRAR ALMAYIN") → 'processing' say.
 */
function isInProgressMessage(payload: QuickSaleWithInvoiceResponse | undefined): boolean {
  return !!payload && /başka bir istekte kaydediliyor/i.test(payload.Message ?? '');
}

/** İstek sunucudan yanıt alamadan mı düştü (zaman aşımı / ağ)? Sonucu belirsizdir. */
function isUncertainFailure(payload: QuickSaleWithInvoiceResponse | undefined): boolean {
  return !!payload && (
    payload.ClientErrorKind === 'zaman-asimi' || payload.ClientErrorKind === 'ag' || isInProgressMessage(payload)
  );
}

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

class SalesService {
  /**
   * Atomik satış kaydını gönderir; sunucu GEÇİCİ bir SQL hatası bildirirse (en sık
   * deadlock 1205) isteği bir kez daha dener.
   *
   * NEDEN GÜVENLİ: Geçici hatalarda transaction SQL tarafında kesin olarak geri
   * alınmıştır — SQL'in kendi tavsiyesi de "Rerun the transaction"dır. Ayrıca aynı
   * IdempotencyKey gönderildiği için, ilk deneme aslında başarılı olup yanıtı
   * kaybolmuşsa sunucu mükerrer kayıt yerine ilk sonucu döndürür.
   *
   * Tekrar deneme yalnızca IdempotencyKey varsa yapılır: anahtar yoksa mükerrer
   * kayıt koruması da yok demektir, o riski almayız.
   */
  private async postAtomicWithInvoice<TRequest extends { IdempotencyKey?: string }>(
    endpoint: string,
    request: TRequest,
    label: string
  ): Promise<QuickSaleWithInvoiceResponse> {
    const maxAttempts = request.IdempotencyKey ? 2 : 1;

    let lastFailure: QuickSaleWithInvoiceResponse = {
      Success: false,
      Message: 'Bilinmeyen bir hata oluştu'
    };

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
      const outcome = await this.sendAtomicRequest(endpoint, request, label, attempt);

      if (outcome.Success) return outcome;

      lastFailure = outcome;

      const canRetry = attempt < maxAttempts && isTransientSqlFailure(outcome);
      if (!canRetry) break;

      console.warn(
        `[salesService] ⏳ ${label}: geçici SQL hatası (SQL ${outcome.SqlErrorNumber ?? '?'}), ` +
        `${TRANSIENT_RETRY_DELAY_MS}ms sonra otomatik tekrar deneniyor...`
      );
      await sleep(TRANSIENT_RETRY_DELAY_MS);
    }

    // Zaman aşımı / ağ kopması / "zaten kaydedilmiş": sonuç belirsiz → sunucuya sor.
    // Anahtar yoksa sorulacak bir şey yok; mevcut davranış korunur.
    if (request.IdempotencyKey && (isUncertainFailure(lastFailure) || isAlreadySavedMessage(lastFailure))) {
      const recovered = await this.waitForIdempotencyResult(request.IdempotencyKey, label);
      if (recovered) return recovered;
    }

    return lastFailure;
  }

  /**
   * GET idempotency-status/{key} ile sunucudaki sonucu bekler (3 sn arayla, en fazla 120 sn).
   * - 'saved'      → saklı yanıt (orijinal POST gövdesi, PascalCase) olduğu gibi döner
   * - 'processing' → beklemeye devam
   * - 'not-found'  → null (istek sunucuya hiç ulaşmamış; aynı anahtarla yeniden denemek güvenli)
   * - uç nokta yok (eski sunucu: 404/405), 400 'invalid', 401 → null (eski davranış)
   * - ağ/zaman aşımı/5xx ('error') → süre dolana kadar tekrar sorar
   * Not: Zaman aşımından sonra aynı isteği yeniden POST etmek sunucu kilidinde 110 sn
   * bekleyebilir; bu yüzden önce durum sorgulanır, yalnızca 'not-found' ise yeniden gönderilir.
   */
  private async waitForIdempotencyResult(
    idempotencyKey: string,
    label: string
  ): Promise<QuickSaleWithInvoiceResponse | null> {
    const deadline = Date.now() + IDEMPOTENCY_POLL_MAX_MS;
    let first = true;

    while (Date.now() < deadline) {
      if (!first) await sleep(IDEMPOTENCY_POLL_INTERVAL_MS);
      first = false;

      try {
        const res = await salesApi.get<any>(
          `/api/QuickSaleWithInvoice/idempotency-status/${encodeURIComponent(idempotencyKey)}`,
          { timeout: 15_000 }
        );
        const data = res.data ?? {};
        const status = String(data.status ?? data.Status ?? '').toLowerCase();
        const stored = (data.response ?? data.Response ?? null) as QuickSaleWithInvoiceResponse | null;

        if (status === 'saved') {
          console.warn(`[salesService] ✅ ${label}: satış sunucuda KAYITLI bulundu (anahtar ${idempotencyKey})`);
          // Saklı yanıt orijinal başarı gövdesidir; olduğu gibi döndürülür. Bu tarayıcı
          // kayıt sonrası adımları henüz çalıştırmamış olabilir — tekrar çalıştırma koruması
          // çağıranda (IdempotencyKey başına bir kez, bkz. atomicSaveRecovery.runOnce).
          return {
            ...(stored ?? {}),
            Success: stored?.Success ?? true,
            Message: stored?.Message ?? 'İşlem başarılı',
            RecoveredFromIdempotency: true
          };
        }
        if (status === 'processing') {
          console.warn(`[salesService] ⏳ ${label}: satış sunucuda hâlâ işleniyor, bekleniyor...`);
          continue;
        }
        if (status === 'not-found') {
          console.warn(`[salesService] ℹ️ ${label}: satış sunucuda yok — aynı anahtarla yeniden denenebilir`);
          return null;
        }
        // Tanınmayan yanıt: eski/farklı sunucu → eski davranış
        return null;
      } catch (error: any) {
        const httpStatus: number | undefined = error?.response?.status;
        if (httpStatus && httpStatus < 500) {
          // 404/405: uç nokta yok (eski sunucu); diğer 4xx: soramıyoruz → eski davranış
          return null;
        }
        // Ağ hâlâ yok / zaman aşımı / 5xx → süre dolana kadar tekrar dene
        console.warn(`[salesService] ⚠️ ${label}: kayıt durumu sorgulanamadı, tekrar denenecek`, error?.message);
      }
    }

    console.warn(`[salesService] ⌛ ${label}: kayıt durumu ${IDEMPOTENCY_POLL_MAX_MS / 1000} sn içinde netleşmedi`);
    return null;
  }

  private async sendAtomicRequest<TRequest>(
    endpoint: string,
    request: TRequest,
    label: string,
    attempt: number
  ): Promise<QuickSaleWithInvoiceResponse> {
    const attemptSuffix = attempt > 1 ? ` (deneme ${attempt})` : '';
    const startedAt = Date.now();

    try {
      console.log(`[salesService] 🔄 ${label} (ATOMİK) çağrıldı${attemptSuffix}:`, request);
      const response = await salesApi.post<QuickSaleWithInvoiceResponse>(endpoint, request);
      console.log(`[salesService] ✅ ${label} yanıtı:`, response.data);
      if (response.data && typeof response.data === 'object' && !response.data.Success) {
        // HTTP 200 + Success=false (iş kuralı hatası): telemetri için teşhis alanlarını ekle
        return {
          ...response.data,
          HttpStatus: response.status,
          DurationMs: Date.now() - startedAt,
          ClientErrorKind: 'sunucu',
          Endpoint: endpoint
        };
      }
      return response.data;
    } catch (error: any) {
      console.error(`[salesService] ❌ ${label} HATA${attemptSuffix}:`, error);
      console.error('[salesService] Response data:', error.response?.data);
      const durationMs = Date.now() - startedAt;
      const httpStatus: number | null = error.response?.status ?? null;

      if (error.response?.data) {
        const data = error.response.data;
        return {
          Success: false,
          Message: data.Message || data.title || 'İşlem başarısız',
          ErrorDetails: data.ErrorDetails || JSON.stringify(data.errors || data),
          IsTransient: data.IsTransient === true,
          SqlErrorNumber: data.SqlErrorNumber ?? null,
          HttpStatus: httpStatus,
          DurationMs: durationMs,
          ClientErrorKind: 'sunucu',
          Endpoint: endpoint
        };
      }

      // Yanıt yok → sonuç BELİRSİZ: zaman aşımı mı (axios "timeout of 60000ms exceeded",
      // ECONNABORTED/ETIMEDOUT) yoksa ağ kopması mı ("Network Error", ERR_NETWORK)?
      const msg: string = error.message || '';
      const isTimeout = error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' || /timeout/i.test(msg);
      const isNetwork = !error.response && (
        error.code === 'ERR_NETWORK' || /network error|failed to fetch/i.test(msg) || !!error.request
      );

      return {
        Success: false,
        Message: msg || 'Bilinmeyen bir hata oluştu',
        HttpStatus: httpStatus,
        DurationMs: durationMs,
        ClientErrorKind: isTimeout ? 'zaman-asimi' : isNetwork ? 'ag' : 'istemci',
        Endpoint: endpoint
      };
    }
  }

  // ========== QUICK SALE SCREEN ==========

  /**
   * Şirkete ait tüm hızlı satış ekranlarını getir
   */
  async getQuickSaleScreens(): Promise<QuickSaleScreenDto[]> {
    const response = await salesApi.get<QuickSaleScreenDto[]>(
      `/api/QuickSaleScreen`
    );
    return response.data;
  }

  /**
   * ID'ye göre hızlı satış ekranı getir
   */
  async getQuickSaleScreenById(id: number): Promise<QuickSaleScreenDto> {
    const response = await salesApi.get<QuickSaleScreenDto>(
      `/api/QuickSaleScreen/${id}`
    );
    return response.data;
  }

  /**
   * Yeni hızlı satış ekranı oluştur
   */
  async createQuickSaleScreen(dto: CreateQuickSaleScreenDto): Promise<QuickSaleScreenDto> {
    const response = await salesApi.post<QuickSaleScreenDto>(
      `/api/QuickSaleScreen`,
      dto
    );
    return response.data;
  }

  /**
   * Hızlı satış ekranını güncelle
   */
  async updateQuickSaleScreen(dto: UpdateQuickSaleScreenDto): Promise<QuickSaleScreenDto> {
    const response = await salesApi.post<QuickSaleScreenDto>(
      `/api/QuickSaleScreen/update`,
      dto
    );
    return response.data;
  }

  /**
   * Hızlı satış ekranını sil
   */
  async deleteQuickSaleScreen(id: number): Promise<void> {
    await salesApi.post(
      `/api/QuickSaleScreen/delete`,
      { Id: id }
    );
  }

  /**
   * Ürün seçim modalı için sayfalama destekli ürün listesi
   * Depo ve kategori filtresi ile - "Tüm Depolar" ve "Tüm Kategoriler" için null gönder
   */
  async getProductsPaged(
    pageNumber: number = 1,
    pageSize: number = 20,
    searchTerm?: string,
    warehouseId?: string | null,
    categoryId?: string | null
  ): Promise<{
    Items?: any[];
    items?: any[];
    TotalCount?: number;
    totalCount?: number;
    PageNumber?: number;
    pageNumber?: number;
    PageSize?: number;
    pageSize?: number;
  }> {
    const params: any = {
      pageNumber,
      pageSize,
    };

    // Sadece değer varsa parametreleri ekle
    if (searchTerm && searchTerm.trim() !== '') {
      params.searchTerm = searchTerm;
    }
    
    // "Tüm Depolar" için warehouseId gönderme (null veya undefined)
    if (warehouseId && warehouseId !== 'all') {
      params.warehouseId = warehouseId;
    }
    
    // "Tüm Kategoriler" için categoryId gönderme (null veya undefined)
    if (categoryId && categoryId !== 'all') {
      params.categoryId = categoryId;
    }

    const response = await salesApi.get(
      `/api/QuickSaleScreen/products/paged`,
      { params }
    );
    
    return response.data;
  }

  /**
   * Belirli ID'lere sahip ürünleri toplu çek (QuickSaleScreen için - OPTIMIZE EDİLMİŞ)
   * @param productIds - Çekilecek ürün ID listesi
   * @returns Ürün listesi
   */
  /**
   * @param options.includeWarehouseStocks
   *   false verildiğinde yanıt ürün başına depo stok satırlarını taşımaz; `totalQuantity`
   *   yine dolu gelir (API tarafında toplanır). Yalnızca toplam stoğa bakan çağrılar için
   *   kullanılır — çok depolu şirketlerde yanıt boyutunu ve zayıf POS makinelerindeki
   *   ayrıştırma süresini belirgin şekilde düşürür.
   */
  async getProductsByIds(
    productIds: string[],
    options?: { includeWarehouseStocks?: boolean }
  ): Promise<any[]> {
    if (!productIds || productIds.length === 0) {
      return [];
    }

    try {
      const response = await salesApi.post<{ Items: any[]; TotalCount: number }>(
        `/api/QuickSaleScreen/products/by-ids`,
        productIds,
        options?.includeWarehouseStocks === false
          ? { params: { includeWarehouseStocks: false } }
          : undefined
      );

      return response.data.Items || [];
    } catch (error) {
      console.error(`❌ [ÜRÜNLER] API hatası:`, error);
      throw error;
    }
  }

  /**
   * Ürün ara (isim veya barkod ile) - QuickSaleScreen arama için
   * @param searchTerm - Arama terimi (ürün adı veya barkod)
   * @param warehouseIds - Arama yapılacak depo ID'leri (opsiyonel)
   * @returns Bulunan ürünler
   */
  async searchProducts(
    searchTerm: string,
    warehouseIds?: string[]
  ): Promise<any[]> {
    if (!searchTerm || searchTerm.trim().length === 0) {
      return [];
    }

    console.log(`🔍 [SALES SERVICE] Ürün aranıyor: "${searchTerm}"`);

    try {
      const response = await salesApi.get(
        `/api/QuickSaleScreen/products/paged`,
        {
          params: {
            searchTerm,
            pageNumber: 1,
            pageSize: 50
          }
        }
      );

      console.log('🔍 [SALES SERVICE] Backend response:', response.data);
      
      // Backend farklı formatlar döndürebilir, hepsini kontrol et
      const items = response.data.Items || response.data.items || response.data || [];
      console.log(`✅ [SALES SERVICE] ${items.length} ürün bulundu`);
      return items;
    } catch (error) {
      console.error(`❌ [SALES SERVICE] Ürün arama hatası:`, error);
      throw error;
    }
  }

  /**
   * Tartı etiketindeki ürün koduyla tek ürün getirir.
   * Ağırlık barkodu okunduğunda çağrılır; kod barkodun ortasındaki 5 hanedir.
   * Ürün yoksa null döner — çağıran taraf normal barkod aramasına düşer.
   */
  async getProductByScaleCode(
    scaleCode: string,
    branchId?: string | null
  ): Promise<any | null> {
    if (!scaleCode) return null;

    try {
      const response = await salesApi.get(
        `/api/QuickSaleScreen/products/by-scale-code`,
        { params: { code: scaleCode, ...(branchId ? { branchId } : {}) } }
      );
      const body = response.data;
      return body?.Data || body?.data || null;
    } catch (error: any) {
      if (error?.response?.status === 404) {
        console.warn(`⚖️ [SALES SERVICE] Tartı kodu "${scaleCode}" ile ürün bulunamadı`);
        return null;
      }
      console.error(`❌ [SALES SERVICE] Tartı kodu araması hatası:`, error);
      throw error;
    }
  }

  /**
   * Ambalaj (kutu/paket/koli/palet) ya da ek barkodla ürün. Bulunamazsa null (normal aramaya devam).
   * package: ambalajsa { unitName, factor, salePrice (null = içerik × adet fiyatı) }, ek barkodsa null.
   */
  async getProductByPackageBarcode(
    code: string,
    branchId?: string | null
  ): Promise<{ product: any; package: { unitName: string; factor: number; salePrice: number | null } | null } | null> {
    if (!code) return null;
    try {
      const response = await salesApi.get(
        `/api/QuickSaleScreen/products/by-package-barcode`,
        { params: { code, ...(branchId ? { branchId } : {}) } }
      );
      const body = response.data || {};
      const product = body.Data || body.data;
      if (!product) return null;
      const raw = body.Package || body.package;
      const factor = Number(raw?.Factor ?? raw?.factor ?? 0);
      const unitName = String(raw?.UnitName ?? raw?.unitName ?? '').trim();
      const priceRaw = raw?.SalePrice ?? raw?.salePrice;
      return {
        product,
        package: raw && unitName && factor > 0
          ? { unitName, factor, salePrice: priceRaw == null ? null : Number(priceRaw) }
          : null,
      };
    } catch (error: any) {
      // 404: ambalaj barkodu değil; eski sunucuda uç yoksa da normal aramaya düşülür.
      if (error?.response?.status === 404 || error?.response?.status === 405) return null;
      console.warn('📦 [SALES SERVICE] Ambalaj barkodu araması başarısız, normal aramaya geçiliyor:', error?.message);
      return null;
    }
  }

  // ========== PACKAGE SCREEN (Sipariş Yönetim Sistemi) ==========

  /**
   * Şirkete ait tüm paket ekranlarını getir
   */
  async getPackageScreens(): Promise<PackageScreenDto[]> {
    const response = await salesApi.get<PackageScreenDto[]>(
      `/api/PackageScreen`
    );
    return response.data;
  }

  /**
   * ID'ye göre paket ekranı getir
   */
  async getPackageScreenById(id: number): Promise<PackageScreenDto> {
    const response = await salesApi.get<PackageScreenDto>(
      `/api/PackageScreen/${id}`
    );
    return response.data;
  }

  /**
   * QuickSaleScreenId'ye göre paket ekranı getir
   */
  async getPackageScreenByQuickSaleScreenId(quickSaleScreenId: number): Promise<PackageScreenDto> {
    const response = await salesApi.get<PackageScreenDto>(
      `/api/PackageScreen/quicksale/${quickSaleScreenId}`
    );
    return response.data;
  }

  /**
   * Yeni paket ekranı oluştur
   */
  async createPackageScreen(dto: CreatePackageScreenDto): Promise<PackageScreenDto> {
    const response = await salesApi.post<PackageScreenDto>(
      `/api/PackageScreen`,
      dto
    );
    return response.data;
  }

  /**
   * Paket ekranı güncelle
   * ⚠️ POST kullanılıyor - PUT desteklenmiyor!
   */
  async updatePackageScreen(dto: UpdatePackageScreenDto): Promise<PackageScreenDto> {
    const response = await salesApi.post<PackageScreenDto>(
      `/api/PackageScreen/update/${dto.Id}`,
      dto
    );
    return response.data;
  }

  /**
   * Paket ekranı sil (soft delete)
   * ⚠️ POST kullanılıyor - DELETE desteklenmiyor!
   */
  async deletePackageScreen(id: number): Promise<void> {
    await salesApi.post(
      `/api/PackageScreen/delete/${id}`
    );
  }

  // ========== PYK SCREEN ==========

  /**
   * Şirkete ait tüm PYK ekranlarını getir
   */
  async getPykScreens(): Promise<PykScreenDto[]> {
    const response = await salesApi.get<PykScreenDto[]>(
      `/api/PykScreen`
    );
    return response.data;
  }

  /**
   * ID'ye göre PYK ekranı getir
   */
  async getPykScreenById(id: number): Promise<PykScreenDto> {
    const response = await salesApi.get<PykScreenDto>(
      `/api/PykScreen/${id}`
    );
    return response.data;
  }

  /**
   * Yeni PYK ekranı oluştur
   */
  async createPykScreen(dto: CreatePykScreenDto): Promise<PykScreenDto> {
    const response = await salesApi.post<PykScreenDto>(
      `/api/PykScreen`,
      dto
    );
    return response.data;
  }

  /**
   * PYK ekranını güncelle
   */
  async updatePykScreen(dto: UpdatePykScreenDto): Promise<PykScreenDto> {
    const response = await salesApi.post<PykScreenDto>(
      `/api/PykScreen/update`,
      dto
    );
    return response.data;
  }

  /**
   * PYK ekranını sil
   */
  async deletePykScreen(id: number): Promise<void> {
    await salesApi.post(
      `/api/PykScreen/delete`,
      { Id: id }
    );
  }

  // ============================================
  // QUICK SALE CASH PAYMENT
  // ============================================

  /**
   * Hızlı satış nakit ödeme işlemi (SQL)
   */
  async processCashPayment(request: QuickSaleCashPaymentRequest): Promise<QuickSaleCashPaymentResponse> {
    try {
      console.log('[salesService] processCashPayment çağrıldı:', request);
      const response = await salesApi.post<QuickSaleCashPaymentResponse>(
        `/api/QuickSaleCashPayment/ProcessCashPayment`,
        request
      );
      console.log('[salesService] processCashPayment yanıtı:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] processCashPayment HATA:', error);
      console.error('[salesService] Response data:', error.response?.data);
      
      // Backend'den validation hatası dönmüşse onu dön
      if (error.response?.data) {
        return {
          Success: false,
          Message: error.response.data.title || 'İstek işlenemedi',
          Errors: error.response.data.errors || error.response.data
        };
      }
      
      // Genel hata durumu
      return {
        Success: false,
        Message: error.message || 'Bilinmeyen bir hata oluştu'
      };
    }
  }

  /**
   * Hızlı satış POS ödeme işlemi (SQL)
   */
  async processPosPayment(request: QuickSalePosPaymentRequest): Promise<QuickSalePosPaymentResponse> {
    try {
      console.log('[salesService] processPosPayment çağrıldı:', request);
      const response = await salesApi.post<QuickSalePosPaymentResponse>(
        `/api/QuickSalePosPayment/ProcessPosPayment`,
        request
      );
      console.log('[salesService] processPosPayment yanıtı:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] processPosPayment HATA:', error);
      console.error('[salesService] Response data:', error.response?.data);
      
      // Backend'den validation hatası dönmüşse onu dön
      if (error.response?.data) {
        return {
          Success: false,
          Message: error.response.data.title || 'İstek işlenemedi',
          ErrorDetails: JSON.stringify(error.response.data.errors || error.response.data)
        };
      }
      
      // Genel hata durumu
      return {
        Success: false,
        Message: error.message || 'Bilinmeyen bir hata oluştu'
      };
    }
  }

  // ============================================
  // ATOMIK HIZLI SATIŞ + FATURA (YENİ)
  // ✅ Tüm işlemler tek transaction içinde
  // ✅ Hata durumunda otomatik rollback
  // ============================================

  /**
   * 🔄 NAKİT + FATURA - ATOMİK İŞLEM
   * TEK TRANSACTION: Cari hareket + Kasa + Stok + Fatura
   */
  async processCashWithInvoice(request: QuickSaleCashWithInvoiceRequest): Promise<QuickSaleWithInvoiceResponse> {
    return this.postAtomicWithInvoice(
      `/api/QuickSaleWithInvoice/process-cash-with-invoice`,
      request,
      'processCashWithInvoice'
    );
  }

  /**
   * 🔄 AÇIK HESAP + FATURA - ATOMİK İŞLEM
   * TEK TRANSACTION: Fatura + Cari BORÇ + Stok (tahsilat/kasa hareketi YOK)
   */
  async processOpenAccountWithInvoice(request: QuickSaleOpenAccountWithInvoiceRequest): Promise<QuickSaleWithInvoiceResponse> {
    return this.postAtomicWithInvoice(
      `/api/QuickSaleWithInvoice/process-open-account-with-invoice`,
      request,
      'processOpenAccountWithInvoice'
    );
  }

  /**
   * 🔄 POS + FATURA - ATOMİK İŞLEM
   * TEK TRANSACTION: Cari hareket + Banka + Stok + Fatura
   */
  async processPosWithInvoice(request: QuickSalePosWithInvoiceRequest): Promise<QuickSaleWithInvoiceResponse> {
    return this.postAtomicWithInvoice(
      `/api/QuickSaleWithInvoice/process-pos-with-invoice`,
      request,
      'processPosWithInvoice'
    );
  }

  /**
   * 🔄 KARMA ÖDEME + FATURA - ATOMİK İŞLEM
   * TEK TRANSACTION: POS Cari + Banka + Nakit Cari + Kasa + Stok + Fatura
   */
  async processPartialWithInvoice(request: QuickSalePartialWithInvoiceRequest): Promise<QuickSaleWithInvoiceResponse> {
    return this.postAtomicWithInvoice(
      `/api/QuickSaleWithInvoice/process-partial-with-invoice`,
      request,
      'processPartialWithInvoice'
    );
  }

  /**
   * POS İade İşlemi - Backend'e negatif bakiye kaydı oluşturur
   */
  async processPosRefund(request: QuickSalePosRefundRequest): Promise<QuickSalePosRefundResponse> {
    try {
      console.log('[salesService] 🔄 processPosRefund çağrıldı:', request);
      const response = await salesApi.post<QuickSalePosRefundResponse>(
        `/api/QuickSaleWithInvoice/process-pos-refund`,
        request
      );
      console.log('[salesService] ✅ processPosRefund yanıtı:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] ❌ processPosRefund HATA:', error);
      return {
        Success: false,
        Message: error.response?.data?.Message || error.message || 'İade işlemi başarısız',
        ErrorDetails: error.response?.data?.ErrorDetails
      };
    }
  }

  /**
   * 💳 DİĞER ÖDEME + FATURA - ATOMİK İŞLEM
   * Multinet, Pluxee, Ticket vb. için kullanılır
   * ❌ YAZARKASA KULLANILMAZ
   * TEK TRANSACTION: Cari hareket + Kasa + Stok + Fatura
   */
  async processOtherPaymentWithInvoice(request: QuickSaleOtherPaymentWithInvoiceRequest): Promise<QuickSaleWithInvoiceResponse> {
    return this.postAtomicWithInvoice(
      `/api/QuickSaleWithInvoice/process-other-payment-with-invoice`,
      request,
      'processOtherPaymentWithInvoice'
    );
  }

  /**
   * 🌐 ONLINE ÖDEME + FATURA - ATOMİK İŞLEM
   * Yemeksepeti, Getir, Trendyol vb. online platformlar için
   * 3 ödeme yöntemi: cash (nakit), pos (kredi kartı), online (platform ödemesi)
   * TEK TRANSACTION: Cari hareket + Kasa/Banka + Stok + Fatura
   */
  async processOnlinePaymentWithInvoice(request: QuickSaleOnlinePaymentWithInvoiceRequest): Promise<QuickSaleWithInvoiceResponse> {
    return this.postAtomicWithInvoice(
      `/api/QuickSaleWithInvoice/process-online-payment-with-invoice`,
      request,
      'processOnlinePaymentWithInvoice'
    );
  }

  /**
   * 🍽️ HIZLI SATIŞ → MUTFAK EKRANI sipariş gönderme
   * Ödeme tamamlandıktan sonra mutfak ekranına sipariş gönderir
   */
  async createKitchenOrderFromQuickSale(request: CreateQuickSaleKitchenOrderRequest): Promise<CreateQuickSaleKitchenOrderResponse> {
    try {
      console.log('[salesService] 🍽️ createKitchenOrderFromQuickSale çağrıldı:', request);
      const response = await salesApi.post<CreateQuickSaleKitchenOrderResponse>(
        `/api/QuickSaleKitchenOrder/create-from-quick-sale`,
        request
      );
      console.log('[salesService] 🍽️ createKitchenOrderFromQuickSale yanıtı:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] 🍽️ createKitchenOrderFromQuickSale HATA:', error);
      console.error('[salesService] Response data:', error.response?.data);
      
      // Backend'den hata dönmüşse onu dön
      if (error.response?.data) {
        return {
          success: false,
          message: error.response.data.message || 'Mutfak ekranına sipariş gönderilemedi',
          error: JSON.stringify(error.response.data)
        };
      }
      
      // Genel hata durumu
      return {
        success: false,
        message: error.message || 'Bilinmeyen bir hata oluştu'
      };
    }
  }

  /**
   * 🎫 SİPARİŞ NUMARASI REZERVASYONU
   * Ekran açıldığında uzun kod ve kısa kod üretir
   * ✅ Hızlı Satış: HS- prefix
   * ✅ Restoran: RS- prefix
   */
  async reserveOrderNumber(type: 'QUICK_SALE' | 'RESTAURANT', branchId?: string): Promise<ReserveOrderNumberResponse> {
    try {
      console.log(`[salesService] 🎫 reserveOrderNumber çağrıldı: type=${type}, branchId=${branchId || 'N/A'}`);
      const response = await salesApi.post<ReserveOrderNumberResponse>(
        `/api/QuickSaleKitchenOrder/reserve-order-number`,
        { type, branchId: branchId || undefined }
      );
      console.log('[salesService] 🎫 reserveOrderNumber yanıtı:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] 🎫 reserveOrderNumber HATA:', error);
      
      // Hata durumunda frontend'de fallback numara üret
      const now = new Date();
      const prefix = type === 'RESTAURANT' ? 'RS' : 'HS';
      const dateStr = now.toISOString().replace(/[-:T]/g, '').slice(0, 14);
      const random6 = Math.floor(100000 + Math.random() * 900000);
      const random3 = Math.floor(100 + Math.random() * 900);
      
      return {
        success: false,
        longCode: `${prefix}-${dateStr}-${random6}`,
        shortCode: `${prefix}-${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}-${random3}`,
        prefix: prefix,
        timestamp: now.toISOString()
      };
    }
  }

  // ========== QUICK SALE RECEIPTS (GÜN SONU RAPORU İÇİN) ==========

  /**
   * 📋 Tarih aralığına göre hızlı satış fişlerini getir (Gün Sonu Raporu için)
   */
  async getQuickSaleReceiptsByDateRange(
    startDate: string,
    endDate: string,
    branchId?: string | null,
    screenId?: number | null,
    eodDiagId?: string | null
  ): Promise<QuickSaleReceiptDto[]> {
    try {
      console.log('[salesService] 📋 getQuickSaleReceiptsByDateRange:', { startDate, endDate, branchId, screenId, eodDiagId });
      
      const params = new URLSearchParams({
        startDate,
        endDate,
      });
      
      if (branchId) params.append('branchId', branchId);
      if (screenId) params.append('screenId', screenId.toString());
      if (eodDiagId) params.append('eodDiagId', eodDiagId);
      
      const response = await salesApi.get<{ Success: boolean; Data: QuickSaleReceiptDto[]; Count: number }>(
        `/api/QuickSaleReceipt/by-date-range?${params.toString()}`
      );
      
      console.log('[salesService] ✅ QuickSaleReceipts:', response.data.Count, 'adet');
      return response.data.Data || [];
    } catch (error: any) {
      console.error('[salesService] ❌ getQuickSaleReceiptsByDateRange HATA:', error);
      return [];
    }
  }

  /**
   * 📊 Yönetici Dashboard "Bugünün Satışları (Şube Bazlı)" — ÖDEME/FİŞ bazlı şube özeti.
   * Gün Sonu raporuyla aynı kaynağı (QuickSaleReceipts) kullanır; ÖKC'siz nakit dahildir.
   */
  async getBranchSalesSummary(
    startDate: string,
    endDate: string,
    branchId?: string | null
  ): Promise<BranchSalesSummaryDto[]> {
    try {
      const params = new URLSearchParams({ startDate, endDate });
      if (branchId) params.append('branchId', branchId);

      const response = await salesApi.get<{ Success: boolean; Data: BranchSalesSummaryDto[]; Count: number }>(
        `/api/QuickSaleReceipt/branch-sales-summary?${params.toString()}`
      );
      return response.data.Data || [];
    } catch (error: any) {
      console.error('[salesService] ❌ getBranchSalesSummary HATA:', error);
      return [];
    }
  }

  /**
   * 🧾 Şube satış detayı (Dashboard modalı) — fiş kalemleri (satılan ürünler), sayfalı.
   * Manuel/hizmet kalemleri de dahildir; toplam, şube özetiyle tutarlıdır.
   * `groupByProduct` ile aynı ürünün kalemleri SQL'de tek satırda toplanır; bu modda
   * sayfalama ürün çeşidi üzerinden yapılır ve UnitPrice ağırlıklı ortalamadır.
   */
  async getBranchSalesItems(params: {
    startDate: string;
    endDate: string;
    branchId?: string | null;
    page: number;
    pageSize: number;
    groupByProduct?: boolean;
  }): Promise<BranchSaleItemsPagedResult> {
    const empty: BranchSaleItemsPagedResult = {
      data: [], totalCount: 0, page: params.page, pageSize: params.pageSize, totalPages: 0,
      totalAmount: 0, totalQuantity: 0, lineCount: 0, groupedByProduct: !!params.groupByProduct,
    };
    try {
      const qp = new URLSearchParams({
        startDate: params.startDate,
        endDate: params.endDate,
        page: params.page.toString(),
        pageSize: params.pageSize.toString(),
      });
      // null şube satırı için sentinel; gerçek şube id'si varsa onu gönder.
      if (params.branchId === null) qp.append('branchId', '_null_');
      else if (params.branchId) qp.append('branchId', params.branchId);
      if (params.groupByProduct) qp.append('groupByProduct', 'true');

      const response = await salesApi.get<any>(
        `/api/QuickSaleReceipt/branch-sales-items?${qp.toString()}`
      );
      const d = response.data;
      return {
        data: d.Data || [],
        totalCount: d.TotalCount || 0,
        page: d.Page || params.page,
        pageSize: d.PageSize || params.pageSize,
        totalPages: d.TotalPages || 0,
        totalAmount: d.Aggregates?.TotalAmount || 0,
        totalQuantity: d.Aggregates?.TotalQuantity || 0,
        lineCount: d.Aggregates?.LineCount || 0,
        groupedByProduct: !!d.GroupedByProduct,
      };
    } catch (error: any) {
      console.error('[salesService] ❌ getBranchSalesItems HATA:', error);
      return empty;
    }
  }

  /**
   * 🖥️ Ekran bazlı en çok satan ürünler (Dashboard "Ekran Bazlı Satışlar" kart takımı).
   * Seçili hızlı satış ekranlarının fişlerine bağlı fatura kalemleri SQL'de gruplanır;
   * yalnızca ilk `limit` ürün + genel toplamlar döner.
   */
  async getScreenTopSellingProducts(
    startDate: string,
    endDate: string,
    screenIds: number[],
    limit: number = 11
  ): Promise<ScreenTopSellingResult> {
    const empty: ScreenTopSellingResult = { data: [], totalAmount: 0, totalQuantity: 0 };
    if (screenIds.length === 0) return empty;
    try {
      const params = new URLSearchParams({
        startDate,
        endDate,
        screenIds: screenIds.join(','),
        limit: limit.toString(),
      });

      const response = await salesApi.get<any>(
        `/api/QuickSaleReceipt/screen-top-selling?${params.toString()}`
      );
      const d = response.data;
      return {
        data: (d.Data || []).map((item: any) => ({
          itemName: item.ItemName ?? item.itemName ?? '',
          totalQuantity: parseFloat(item.TotalQuantity ?? item.totalQuantity) || 0,
          totalAmount: parseFloat(item.TotalAmount ?? item.totalAmount) || 0,
        })),
        totalAmount: parseFloat(d.Totals?.TotalAmount ?? d.totals?.totalAmount) || 0,
        totalQuantity: parseFloat(d.Totals?.TotalQuantity ?? d.totals?.totalQuantity) || 0,
      };
    } catch (error: any) {
      console.error('[salesService] ❌ getScreenTopSellingProducts HATA:', error);
      return empty;
    }
  }

  /**
   * 🍽️ Restoran ekranı bazlı en çok satan ürünler (Dashboard restoran kart takımı).
   * Seçili restoran ekranlarının tamamlanmış satış kalemleri SQL'de gruplanır;
   * yalnızca ilk `limit` ürün + genel toplamlar döner. İptal/ödenmemiş adisyonlar hariçtir.
   */
  async getRestaurantScreenTopSellingProducts(
    startDate: string,
    endDate: string,
    screenIds: number[],
    limit: number = 11
  ): Promise<ScreenTopSellingResult> {
    const empty: ScreenTopSellingResult = { data: [], totalAmount: 0, totalQuantity: 0 };
    if (screenIds.length === 0) return empty;
    try {
      const params = new URLSearchParams({
        startDate,
        endDate,
        screenIds: screenIds.join(','),
        limit: limit.toString(),
      });

      const response = await salesApi.get<any>(
        `/api/QuickSaleReceipt/restaurant-screen-top-selling?${params.toString()}`
      );
      const d = response.data;
      return {
        data: (d.Data || []).map((item: any) => ({
          itemName: item.ItemName ?? item.itemName ?? '',
          totalQuantity: parseFloat(item.TotalQuantity ?? item.totalQuantity) || 0,
          totalAmount: parseFloat(item.TotalAmount ?? item.totalAmount) || 0,
        })),
        totalAmount: parseFloat(d.Totals?.TotalAmount ?? d.totals?.totalAmount) || 0,
        totalQuantity: parseFloat(d.Totals?.TotalQuantity ?? d.totals?.totalQuantity) || 0,
      };
    } catch (error: any) {
      console.error('[salesService] ❌ getRestaurantScreenTopSellingProducts HATA:', error);
      return empty;
    }
  }

  /**
   * 📦 Paket sipariş ekranı bazlı en çok satan ürünler (Dashboard paket kart takımı).
   * Seçilen paket ekranlarının şubelerindeki paket siparişlerinin kalemleri SQL'de gruplanır;
   * yalnızca ilk `limit` ürün + genel toplamlar döner. İptal edilen siparişler/kalemler hariçtir.
   */
  async getPackageScreenTopSellingProducts(
    startDate: string,
    endDate: string,
    screenIds: number[],
    limit: number = 11
  ): Promise<ScreenTopSellingResult> {
    const empty: ScreenTopSellingResult = { data: [], totalAmount: 0, totalQuantity: 0 };
    if (screenIds.length === 0) return empty;
    try {
      const params = new URLSearchParams({
        startDate,
        endDate,
        screenIds: screenIds.join(','),
        limit: limit.toString(),
      });

      const response = await salesApi.get<any>(
        `/api/QuickSaleReceipt/package-screen-top-selling?${params.toString()}`
      );
      const d = response.data;
      return {
        data: (d.Data || []).map((item: any) => ({
          itemName: item.ItemName ?? item.itemName ?? '',
          totalQuantity: parseFloat(item.TotalQuantity ?? item.totalQuantity) || 0,
          totalAmount: parseFloat(item.TotalAmount ?? item.totalAmount) || 0,
        })),
        totalAmount: parseFloat(d.Totals?.TotalAmount ?? d.totals?.totalAmount) || 0,
        totalQuantity: parseFloat(d.Totals?.TotalQuantity ?? d.totals?.totalQuantity) || 0,
      };
    } catch (error: any) {
      console.error('[salesService] ❌ getPackageScreenTopSellingProducts HATA:', error);
      return empty;
    }
  }

  /**
   * 📊 Dinamik Rapor Motoru: kullanıcı tanımlı rapor kartının (ReportSpec) verisini çeker.
   * Kaynak/metrik/boyut/filtre id'leri backend whitelist'inden doğrulanır (geçersiz id → 400).
   */
  async runDynamicReport(
    spec: DynamicReportSpecInput,
    startDate: string,
    endDate: string,
    signal?: AbortSignal
  ): Promise<DynamicReportResult> {
    const response = await salesApi.post<any>(
      '/api/DynamicReport/run',
      {
        dataSource: spec.dataSource,
        metric: spec.metric,
        dimension: spec.dimension,
        timeGranularity: spec.dimension === 'time' ? spec.timeGranularity ?? 'day' : null,
        filters: (spec.filters || [])
          .filter((f) => f.values.length > 0)
          .map((f) => ({ field: f.field, values: f.values })),
        limit: spec.limit || 10,
        startDate,
        endDate,
      },
      { signal }
    );
    const d = response.data;
    if (d?.Success === false) {
      throw new Error(d?.Message || 'Dynamic report failed');
    }
    return {
      data: (d.Data || []).map((row: any) => ({
        key: row.Key ?? row.key ?? '',
        label: row.Label ?? row.label ?? '',
        value: parseFloat(row.Value ?? row.value) || 0,
      })),
      totalValue: parseFloat(d.Totals?.Value ?? d.totals?.value) || 0,
      totalCount: parseInt(d.Totals?.Count ?? d.totals?.count, 10) || 0,
    };
  }

  /**
   * 📖 Dinamik rapor motorunun makine-okur kataloğu (backend whitelist).
   * Frontend sürüm kayması tespiti için kullanılır.
   * NOT: AI asistan aktiflik bilgisi artık aiChatService.getAiReportStatus()'tan gelir
   * (AI katmanı gts_ai_api'ye taşındı — Temmuz 2026).
   */
  async getDynamicReportCatalog(): Promise<DynamicReportCatalog> {
    const response = await salesApi.get<any>('/api/DynamicReport/catalog');
    const d = response.data;
    if (d?.Success === false) {
      throw new Error(d?.Message || 'Dynamic report catalog failed');
    }
    const data = d.Data || {};
    return {
      sources: (data.Sources || []).map((s: any) => ({
        sourceId: s.SourceId ?? '',
        label: s.Label ?? '',
        metrics: (s.Metrics || []).map((m: any) => m.Id as string),
        dimensions: (s.Dimensions || []).map((m: any) => m.Id as string),
        filters: (s.Filters || []).map((m: any) => m.Id as string),
      })),
      timeGranularities: data.TimeGranularities || [],
    };
  }

  // ℹ️ AI CHAT ASSISTANT fonksiyonları aiChatService.ts'e taşındı (gts_ai_api — Temmuz 2026).

  /**
   * 💳 PYK ön ödemeli (kart) fiş kesme için QuickSaleReceipt oluştur.
   * Gün Sonu raporunda "Ön Ödemeli" olarak görünmesi içindir; kasa/banka hareketi oluşturmaz
   * (para zaten bakiye yükleme anında girmiştir).
   */
  async createPrepaidReceipt(dto: CreatePrepaidReceiptInput): Promise<number | null> {
    try {
      const response = await salesApi.post<{ Success: boolean; Data: { Id: number } }>(
        '/api/QuickSaleReceipt/prepaid',
        dto
      );
      console.log('[salesService] ✅ Ön ödemeli fiş oluşturuldu, ID:', response.data?.Data?.Id);
      return response.data?.Data?.Id ?? null;
    } catch (error: any) {
      console.error('[salesService] ❌ createPrepaidReceipt HATA:', error);
      throw error;
    }
  }

  /**
   * 📋 Tek bir hızlı satış fişini ödemeleriyle birlikte getir
   */
  async getQuickSaleReceiptById(id: number): Promise<QuickSaleReceiptDto | null> {
    try {
      const response = await salesApi.get<{ Success: boolean; Data: QuickSaleReceiptDto }>(
        `/api/QuickSaleReceipt/${id}`
      );
      return response.data.Data || null;
    } catch (error: any) {
      console.error('[salesService] ❌ getQuickSaleReceiptById HATA:', error);
      return null;
    }
  }

  // ========== QUICK SALE CASHIER (KASİYER YÖNETİMİ) ==========

  /**
   * 👤 Normal hızlı satış ekranına atanmış kasiyerleri getir
   */
  async getCashiersByQuickSaleScreenId(quickSaleScreenId: number): Promise<QuickSaleCashierDto[]> {
    try {
      console.log('[salesService] 👤 getCashiersByQuickSaleScreenId:', quickSaleScreenId);
      const response = await salesApi.get<QuickSaleCashierDto[]>(
        `/api/QuickSaleCashier/quicksale-screen/${quickSaleScreenId}`
      );
      console.log('[salesService] ✅ Kasiyerler:', response.data.length, 'adet');
      return response.data || [];
    } catch (error: any) {
      console.error('[salesService] ❌ getCashiersByQuickSaleScreenId HATA:', error);
      return [];
    }
  }

  /**
   * 👤 Restoran ekranına atanmış kasiyerleri getir
   */
  async getCashiersByRestaurantScreenId(restaurantScreenId: number): Promise<QuickSaleCashierDto[]> {
    try {
      console.log('[salesService] 👤 getCashiersByRestaurantScreenId:', restaurantScreenId);
      const response = await salesApi.get<QuickSaleCashierDto[]>(
        `/api/QuickSaleCashier/restaurant-screen/${restaurantScreenId}`
      );
      console.log('[salesService] ✅ Kasiyerler:', response.data.length, 'adet');
      return response.data || [];
    } catch (error: any) {
      console.error('[salesService] ❌ getCashiersByRestaurantScreenId HATA:', error);
      return [];
    }
  }

  /**
   * 👤 PYK ekranına atanmış kasiyerleri getir
   */
  async getCashiersByPykScreenId(pykScreenId: number): Promise<QuickSaleCashierDto[]> {
    try {
      console.log('[salesService] 👤 getCashiersByPykScreenId:', pykScreenId);
      const response = await salesApi.get<QuickSaleCashierDto[]>(
        `/api/QuickSaleCashier/pyk-screen/${pykScreenId}`
      );
      console.log('[salesService] ✅ Kasiyerler:', response.data.length, 'adet');
      return response.data || [];
    } catch (error: any) {
      console.error('[salesService] ❌ getCashiersByPykScreenId HATA:', error);
      return [];
    }
  }

  /**
   * 👤 Yeni kasiyer ekle
   */
  async createCashier(data: CreateQuickSaleCashierDto): Promise<QuickSaleCashierDto | null> {
    try {
      console.log('[salesService] 👤 createCashier:', data.CashierName);
      const response = await salesApi.post<QuickSaleCashierDto>(
        `/api/QuickSaleCashier`,
        data
      );
      console.log('[salesService] ✅ Kasiyer eklendi:', response.data.Id);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] ❌ createCashier HATA:', error);
      throw error;
    }
  }

  /**
   * 👤 Kasiyer güncelle
   */
  async updateCashier(id: number, data: UpdateQuickSaleCashierDto): Promise<QuickSaleCashierDto | null> {
    try {
      console.log('[salesService] 👤 updateCashier:', id);
      const response = await salesApi.post<QuickSaleCashierDto>(
        `/api/QuickSaleCashier/update/${id}`,
        data
      );
      console.log('[salesService] ✅ Kasiyer güncellendi:', response.data.Id);
      return response.data;
    } catch (error: any) {
      console.error('[salesService] ❌ updateCashier HATA:', error);
      throw error;
    }
  }

  /**
   * 💰 Kasiyerlere atanmış Cari Tahsilat kasa/banka hesapları.
   * Dönüş: { [cashierId]: kaynaklar } — ataması olmayan kasiyer listede yer almaz.
   */
  async getCashierCollectionSources(cashierIds: number[]): Promise<Record<number, CashierCollectionSource[]>> {
    if (cashierIds.length === 0) return {};
    const response = await salesApi.get<Record<string, any[]>>(
      `/api/QuickSaleCashier/collection-sources`,
      { params: { cashierIds: cashierIds.join(',') } }
    );
    const result: Record<number, CashierCollectionSource[]> = {};
    Object.entries(response.data || {}).forEach(([key, list]) => {
      result[Number(key)] = (list || []).map((s: any) => ({
        SourceType: (s.SourceType ?? s.sourceType) as 'cashbox' | 'bank',
        SourceId: Number(s.SourceId ?? s.sourceId),
        SubAccountId: (s.SubAccountId ?? s.subAccountId) ?? null,
      }));
    });
    return result;
  }

  /**
   * 💰 Kasiyerin Cari Tahsilat kasa/banka listesini toptan değiştirir (boş liste = hiçbiri).
   */
  async setCashierCollectionSources(cashierId: number, sources: CashierCollectionSource[]): Promise<void> {
    await salesApi.post(`/api/QuickSaleCashier/collection-sources/${cashierId}`, { Sources: sources });
  }

  /**
   * 👤 Kasiyer sil
   */
  async deleteCashier(id: number): Promise<boolean> {
    try {
      console.log('[salesService] 👤 deleteCashier:', id);
      await salesApi.post(`/api/QuickSaleCashier/delete/${id}`);
      console.log('[salesService] ✅ Kasiyer silindi:', id);
      return true;
    } catch (error: any) {
      console.error('[salesService] ❌ deleteCashier HATA:', error);
      return false;
    }
  }

  /**
   * 🔐 Kasiyer PIN doğrulama (Giriş için)
   */
  async validateCashierPin(data: ValidateCashierPinDto): Promise<ValidateCashierResponseDto> {
    try {
      console.log('[salesService] 🔐 validateCashierPin:', data.ScreenType, data.QuickSaleScreenId || data.RestaurantScreenId || data.PykScreenId);
      const response = await salesApi.post<ValidateCashierResponseDto>(
        `/api/QuickSaleCashier/validate-pin`,
        data
      );
      if (response.data.IsValid) {
        console.log('[salesService] ✅ Kasiyer giriş yaptı:', response.data.CashierName);
      } else {
        console.log('[salesService] ⚠️ Geçersiz kasiyer şifresi');
      }
      return response.data;
    } catch (error: any) {
      console.error('[salesService] ❌ validateCashierPin HATA:', error);
      return { IsValid: false, Message: 'Doğrulama hatası' };
    }
  }
}

// ============================================
// 📋 QUICK SALE RECEIPT TYPES (GÜN SONU RAPORU)
// ============================================

export interface BranchSalesSummaryDto {
  BranchId: string | null;
  TotalAmount: number;
  ReceiptCount: number;
}

export interface BranchSaleItemDto {
  ProductName: string;
  Quantity: number;
  Unit: string;
  UnitPrice: number;
  Total: number;
  IsManualItem: boolean;
  Date: string;
}

export interface BranchSaleItemsPagedResult {
  data: BranchSaleItemDto[];
  /** Gruplu modda ürün çeşidi, aksi halde kalem sayısı (sayfalama bu değere göredir). */
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  totalAmount: number;
  /** Dönemdeki toplam satılan miktar (gruplamadan bağımsız). */
  totalQuantity: number;
  /** Gruplamadan bağımsız ham kalem sayısı. */
  lineCount: number;
  groupedByProduct: boolean;
}

export interface ScreenTopSellingProduct {
  itemName: string;
  totalQuantity: number;
  totalAmount: number;
}

export interface ScreenTopSellingResult {
  data: ScreenTopSellingProduct[];
  totalAmount: number;
  totalQuantity: number;
}

/** Dinamik rapor isteği için gereken ReportSpec alanları (id/title/visual hariç) */
export interface DynamicReportSpecInput {
  dataSource: string;
  metric: string;
  dimension: string;
  timeGranularity?: string;
  filters: Array<{ field: string; values: string[] }>;
  limit: number;
}

export interface DynamicReportRow {
  key: string;
  label: string;
  value: number;
}

export interface DynamicReportResult {
  data: DynamicReportRow[];
  totalValue: number;
  totalCount: number;
}

export interface DynamicReportCatalogSource {
  sourceId: string;
  label: string;
  metrics: string[];
  dimensions: string[];
  filters: string[];
}

export interface DynamicReportCatalog {
  sources: DynamicReportCatalogSource[];
  timeGranularities: string[];
}

// ℹ️ AI CHAT ASSISTANT tipleri ve mapper'ları aiChatService.ts'e taşındı (gts_ai_api — Temmuz 2026).

export interface QuickSaleReceiptDto {
  Id: number;
  BranchId?: string | null;
  ScreenId?: number | null;
  ReceiptNumber: string;
  ShortCode?: string | null;
  InvoiceId?: string | null;
  InvoiceNumber?: string | null;
  ReferenceNumber?: string | null;
  SubTotal: number;
  DiscountAmount: number;
  TaxAmount: number;
  TotalAmount: number;
  AccountId: number;
  AccountName?: string | null;
  PaymentStatus: string; // 'PAID' | 'UNPAID' | 'PARTIAL'
  TotalPaid: number;
  RemainingAmount: number;
  PaymentType: string; // 'CASH' | 'POS' | 'PARTIAL' | 'PREPAID'
  OpenedAt: string;
  CompletedAt?: string | null;
  CreatedBy?: string | null;
  CreatedByName?: string | null;
  CashierId?: number | null;
  CashierName?: string | null;
  Notes?: string | null;
  CreatedAt: string;
  IsFiscalReceipt?: boolean;
  Payments?: QuickSaleReceiptPaymentDto[];
}

export interface CreatePrepaidReceiptInput {
  branchId?: string | null;
  screenId?: number | null;
  invoiceId?: string | null;
  invoiceNumber?: string | null;
  accountId: number;
  accountName?: string | null;
  subTotal: number;
  taxAmount: number;
  totalAmount: number;
  createdBy?: string | null;
  notes?: string | null;
}

export interface QuickSaleReceiptPaymentDto {
  Id: number;
  PaymentMethod: string; // 'cash' | 'pos' | 'prepaid'
  Amount: number;
  PaymentPercentage?: number | null;
  CashboxId?: number | null;
  CashboxName?: string | null;
  BankAccountId?: number | null;
  BankAccountName?: string | null;
  BankSubAccountId?: number | null;
  BankSubAccountName?: string | null;
  AuthCode?: string | null;
  CardType?: string | null;
  CreatedAt: string;
  // ✅ YENİ: Online platform bilgileri (Yemek Sepeti, Getir vb.)
  PaymentProviderType?: string | null;
  PaymentProviderId?: string | null;
  PaymentProviderName?: string | null;
}

// ============================================
// 🎫 SİPARİŞ NUMARASI REZERVASYON TİPLERİ
// ============================================

export interface ReserveOrderNumberResponse {
  success: boolean;
  longCode: string;
  shortCode: string;
  prefix: string;
  timestamp: string;
}

// ============================================
// QUICK SALE CASH PAYMENT TYPES
// ============================================

export interface QuickSaleCashPaymentRequest {
  ScreenId?: number | null;
  AccountId: number;
  AccountName: string;
  CashboxId: number;
  TotalAmount: number;
  Currency?: string;
  Description?: string | null;
  CreatedBy?: string | null;
  BranchId?: string | null;
  Items: QuickSaleItemDto[];
}

export interface QuickSaleItemDto {
  ProductId: string;
  ProductName: string;
  StockCode?: string | null;
  WarehouseId: string;
  WarehouseName?: string | null;
  Quantity: number;
  Unit?: string | null;
  UnitPrice: number;
  LineTotal: number;
  VatRate?: number | null;
  SctRate?: number | null;
  VatAmount?: number | null;
  SctAmount?: number | null;
  GrossTotal: number;
}

export interface QuickSaleCashPaymentResponse {
  Success: boolean;
  Message: string;
  ReferenceNumber?: string | null;
  AccountTransactionId?: number | null;
  CashboxTransactionId?: number | null;
  StockMovementIds?: string[];
  Errors?: Record<string, any>;
}

// ============================================
// 🍽️ MUTFAK EKRANI (QUICK SALE → KITCHEN SCREEN)
// ============================================

export interface CreateQuickSaleKitchenOrderRequest {
  QRMenuId: string;
  PersonelFirebaseUid?: string | null;
  PersonelName: string;
  ToplamTutar: number;
  SiparisDetaylari: QuickSaleKitchenOrderItem[];
  SiparisNotu?: string | null;
  OdemeYontemi: string; // "Nakit" | "Kredi Kartı" | "Karma"
  IslemId?: string | null;
  DekontId?: string | null;
  QuickSaleScreenId?: number | null;
  ReferenceNumber?: string | null;
  // ✅ YENİ: Restoran Hızlı Satış Desteği
  IsRestaurantMode?: boolean; // true ise RS- prefix, false ise HS- prefix
  ReservedLongCode?: string | null; // Önceden rezerve edilmiş uzun kod (RS-20260109-141039-817)
  ReservedShortCode?: string | null; // Önceden rezerve edilmiş kısa kod (RS-5)
  BranchId?: string | null; // Şube ID (Branch bazında benzersiz numara için)
  IsPaymentUpdate?: boolean; // Ödeme sonrası güncelleme (restoran modu - duplikasyon önleme)
  TableName?: string | null; // Masa adı (restoran modu - fişte gösterilmek üzere)
  CustomerAccountName?: string | null; // Cari hesap adı (restoran modu - fişte gösterilmek üzere)
}

export interface QuickSaleKitchenOrderItem {
  UrunId: string;
  UrunAdi: string;
  BirimFiyat: number;
  Miktar: number;
  ToplamFiyat: number;
  UrunResmi?: string | null;
  Aciklama?: string | null;
  CategoryId?: string | null;
  VatRate?: number | null;
}

export interface CreateQuickSaleKitchenOrderResponse {
  success: boolean;
  message: string;
  data?: {
    siparisId: string;
    shortCode: string; // QS-5
    siparisNo: number;
    kullaniciAdi: string;
    toplamTutar: number;
    siparisDurumu: string;
    siparisOlusturmaTarihi: string;
  };
  error?: string;
}

// ============================================
// QUICK SALE POS PAYMENT TYPES
// ============================================

export interface QuickSalePosPaymentRequest {
  ScreenId: number;
  AccountId: number;
  AccountName?: string | null;
  BankAccountId: number;
  BankSubAccountId?: number | null;
  BankAccountName?: string | null;
  TotalAmount: number;
  Currency?: string;
  Description?: string | null;
  AuthCode?: string | null;
  BatchNo?: string | null;
  MaskedCardNumber?: string | null;
  FiscalTransactionId?: string | null;
  CardType?: string | null;
  CreatedBy?: string | null;
  CartItems: QuickSalePosCartItemDto[];
  SkipStockMovement?: boolean; // ✅ YENİ: Karma ödemede stok hareketini atla
}

export interface QuickSalePosCartItemDto {
  ProductId: string;
  WarehouseId: string | null;
  ProductName?: string | null;
  Quantity: number;
  UnitPrice: number;
  TotalPrice: number;
  VatRate?: number | null;  // ✅ YENİ: KDV oranı
  SctRate?: number | null;  // ✅ YENİ: ÖTV oranı
}

export interface QuickSalePosPaymentResponse {
  Success: boolean;
  Message: string;
  ReferenceNumber?: string | null;
  AccountTransactionId?: number | null;
  BankTransactionId?: number | null;
  StockMovementIds?: string[];
  TransactionDate?: string;
  ErrorDetails?: string | null;
}

// ============================================
// ATOMIK HIZLI SATIŞ + FATURA (YENİ)
// ✅ Tüm işlemler tek transaction içinde
// ✅ Hata durumunda otomatik rollback
// ============================================

// Nakit + Fatura Request DTO
export interface QuickSaleCashWithInvoiceRequest {
  IdempotencyKey?: string;
  // ✅ YENİ: Sepete uygulanan indirim kaydı
  DiscountType?: string | null; // 'PERCENTAGE' | 'AMOUNT' | null
  DiscountRate?: number | null;
  DiscountAmount?: number | null; // KDV dahil toplam indirim
  CompanyName?: string | null; // ✅ YENİ: Şirket adı (Fatura numarası için)
  ScreenId?: number | null;
  AccountId: number;
  AccountName?: string | null;
  CashboxId: number;
  CashboxName?: string | null; // ✅ YENİ: Kasa adı (Gün sonu raporu için)
  TotalAmount: number;
  Currency?: string | null;
  Description?: string | null;
  CreatedBy?: string | null;
  BranchId?: number | null; // ✅ Gün sonu raporu için kritik!
  BranchName?: string | null; // ✅ YENİ: Kasa hareket raporu için şube adı
  IsRestaurantMode?: boolean; // ✅ YENİ: Restoran modu için RS- prefix
  CashierId?: number | null; // ✅ YENİ: Kasiyer ID (gün sonu raporu için)
  CashierName?: string | null; // ✅ YENİ: Kasiyer adı (gün sonu raporu için)
  IsFiscalReceipt?: boolean;
  PavoPaySaleNumber?: string | null;
  PavoPayInvoiceNo?: string | null;
  EInvoiceETTN?: string | null;
  PavoPayInquiryLink?: string | null;
  Items: QuickSaleCashWithInvoiceItem[];
}

export interface QuickSaleCashWithInvoiceItem {
  ProductId: string;
  ProductName?: string | null;
  StockCode?: string | null;
  WarehouseId: string;
  WarehouseName?: string | null;
  Quantity: number;
  Unit?: string | null;
  UnitPrice: number;
  VatRate?: number | null;
  SctRate?: number | null;
  // ✅ YENİ: KDV Dahil/Hariç bilgisi (fatura hesaplaması için)
  // vatStatus='included' → PriceType='VAT_INCLUDED'
  // vatStatus='excluded' → PriceType='VAT_EXCLUDED'
  PriceType?: string | null;
  // ✅ Reçete/Menü bazlı stok düşme için
  HasRecipe?: boolean;
  HasMenu?: boolean;
  // ✅ YENİ: İndirim kaydı (faturaya gerçek indirim yazmak için)
  OriginalPrice?: number | null; // İndirim öncesi birim fiyat (kalemin KDV tabanında)
  DiscountRate?: number;
  DiscountAmount?: number; // Kalemin KDV tabanında, miktar dahil toplam indirim
}

// Açık Hesap + Fatura Request DTO (tahsilat/kasa hareketi olmadan)
export interface QuickSaleOpenAccountWithInvoiceRequest {
  IdempotencyKey?: string;
  DiscountType?: string | null;
  DiscountRate?: number | null;
  DiscountAmount?: number | null;
  CompanyName?: string | null;
  ScreenId?: number | null;
  AccountId: number;
  AccountName?: string | null;
  TotalAmount: number;
  Currency?: string | null;
  Description?: string | null;
  CreatedBy?: string | null;
  BranchId?: number | null;
  BranchName?: string | null;
  IsRestaurantMode?: boolean;
  CashierId?: number | null;
  CashierName?: string | null;
  Items: QuickSaleCashWithInvoiceItem[];
}

// POS + Fatura Request DTO
export interface QuickSalePosWithInvoiceRequest {
  IdempotencyKey?: string;
  DiscountType?: string | null;
  DiscountRate?: number | null;
  DiscountAmount?: number | null;
  CompanyName?: string | null; // ✅ YENİ: Şirket adı (Fatura numarası için)
  ScreenId?: number | null;
  AccountId: number;
  AccountName?: string | null;
  BankAccountId: number;
  BankSubAccountId?: number | null;
  BankAccountName?: string | null;
  TotalAmount: number;
  Currency?: string | null;
  Description?: string | null;
  AuthCode?: string | null;
  BatchNo?: string | null;
  MaskedCardNumber?: string | null;
  FiscalTransactionId?: string | null;
  CardType?: string | null;
  CreatedBy?: string | null;
  BranchId?: number | null; // ✅ YENİ: Gün sonu raporu için kritik!
  BranchName?: string | null; // ✅ YENİ: Kasa hareket raporu için şube adı
  IsRestaurantMode?: boolean; // ✅ YENİ: Restoran modu için RS- prefix
  CashierId?: number | null; // ✅ YENİ: Kasiyer ID (gün sonu raporu için)
  CashierName?: string | null; // ✅ YENİ: Kasiyer adı (gün sonu raporu için)
  IsFiscalReceipt?: boolean;
  PavoPaySaleNumber?: string | null;
  PavoPayInvoiceNo?: string | null;
  EInvoiceETTN?: string | null;
  PavoPayInquiryLink?: string | null;
  Items: QuickSalePosWithInvoiceItem[];
}

export interface QuickSalePosWithInvoiceItem {
  ProductId: string;
  ProductName?: string | null;
  WarehouseId?: string | null;
  Quantity: number;
  UnitPrice: number;
  // ✅ YENİ: KDV Dahil/Hariç bilgisi (fatura hesaplaması için)
  PriceType?: string | null;
  // ✅ Reçete/Menü bazlı stok düşme için
  HasRecipe?: boolean;
  HasMenu?: boolean;
  VatRate?: number | null;
  SctRate?: number | null;
  // ✅ YENİ: İndirim kaydı (faturaya gerçek indirim yazmak için)
  OriginalPrice?: number | null;
  DiscountRate?: number;
  DiscountAmount?: number;
}

// Karma Ödeme + Fatura Request DTO
export interface QuickSalePartialWithInvoiceRequest {
  IdempotencyKey?: string;
  DiscountType?: string | null;
  DiscountRate?: number | null;
  DiscountAmount?: number | null;
  CompanyName?: string | null; // ✅ YENİ: Şirket adı (Fatura numarası için)
  ScreenId?: number | null;
  AccountId: number;
  AccountName?: string | null;
  // POS Bilgileri
  BankAccountId: number;
  BankSubAccountId?: number | null;
  BankAccountName?: string | null;
  PosAmount: number;
  // Nakit Bilgileri
  CashboxId: number;
  CashboxName?: string | null; // ✅ YENİ: Kasa adı (Gün sonu raporu için)
  CashAmount: number;
  // Ortak
  Currency?: string | null;
  Description?: string | null; // ✅ YENİ: Fatura açıklaması (Restoran modu için)
  BranchId?: number | null; // ✅ YENİ: Gün sonu raporu için kritik!
  BranchName?: string | null; // ✅ YENİ: Kasa hareket raporu için şube adı
  IsRestaurantMode?: boolean; // ✅ YENİ: Restoran modu için RS- prefix
  CashierId?: number | null; // ✅ YENİ: Kasiyer ID (gün sonu raporu için)
  CashierName?: string | null; // ✅ YENİ: Kasiyer adı (gün sonu raporu için)
  // POS Detayları
  AuthCode?: string | null;
  BatchNo?: string | null;
  MaskedCardNumber?: string | null;
  FiscalTransactionId?: string | null;
  CardType?: string | null;
  CreatedBy?: string | null;
  IsFiscalReceipt?: boolean;
  PavoPaySaleNumber?: string | null;
  PavoPayInvoiceNo?: string | null;
  EInvoiceETTN?: string | null;
  PavoPayInquiryLink?: string | null;
  Items: QuickSalePosWithInvoiceItem[];
}

// Ortak Response DTO (Nakit, POS, Karma için)
export interface QuickSaleWithInvoiceResponse {
  Success: boolean;
  Message?: string | null;
  ErrorDetails?: string | null;
  /**
   * Hata geçici bir SQL sorunundan mı kaynaklandı (deadlock, timeout, bağlantı kopması)?
   * True ise transaction kesin geri alınmıştır; aynı istek tekrarlanabilir.
   */
  IsTransient?: boolean;
  /** Asıl SqlException numarası (ör. 1205 deadlock). Teşhis için. */
  SqlErrorNumber?: number | null;
  // ── Aşağıdaki 5 alanı yalnızca istemci doldurur (sunucu göndermez) — kayıt hatası telemetrisi ──
  /** Hata yanıtının HTTP durumu (yanıt hiç gelmediyse null) */
  HttpStatus?: number | null;
  /** İsteğin süresi (ms) */
  DurationMs?: number | null;
  /** Hata türü: zaman-asimi / ag (yanıt yok, sonuç belirsiz) · sunucu (yanıt geldi) */
  ClientErrorKind?: 'zaman-asimi' | 'ag' | 'sunucu' | 'istemci' | null;
  /** Çağrılan uç nokta */
  Endpoint?: string | null;
  /** Zaman aşımı/ağ hatası sonrası idempotency-status ile sunucuda KAYITLI bulundu */
  RecoveredFromIdempotency?: boolean;
  /** Sunucu yeni satış oluşturmadı, aynı anahtarın saklı ilk yanıtını döndürdü */
  IsReplay?: boolean;
  /** Engellemeyen uyarılar (ör. eksi stok) */
  Warnings?: string[] | null;
  ReferenceNumber?: string | null;
  AccountTransactionId?: number | null;
  BankTransactionId?: number | null;
  CashTransactionId?: number | null;
  StockMovementIds?: string[];
  InvoiceId?: string | null;
  InvoiceNumber?: string | null;
  TransactionDate?: string | null;
  QuickSaleReceiptId?: number | null;
}

// ============================================
// POS İade DTO'ları
// ============================================

export interface QuickSalePosRefundRequest {
  PavoPaySaleNumber: string;
  RefundAmount: number;
  CreatedBy?: string;
  Description?: string;
}

export interface QuickSalePosRefundResponse {
  Success: boolean;
  Message?: string;
  ErrorDetails?: string;
  RefundReceiptId?: number;
  BankTransactionId?: number;
  /** Normal hızlı satış iadesinde atomik silinen fatura numaraları (stok/cari/gün sonu dahil temizlendi) */
  DeletedInvoiceNumbers?: string[];
}

// ============================================
// 💳 DİĞER ÖDEME TİPLERİ
// ============================================

/**
 * Diğer Ödeme + Fatura Request DTO
 * Multinet, Pluxee, Ticket vb. için kullanılır
 */
export interface QuickSaleOtherPaymentWithInvoiceRequest {
  IdempotencyKey?: string;
  DiscountType?: string | null;
  DiscountRate?: number | null;
  DiscountAmount?: number | null;
  CompanyName?: string | null;
  ScreenId?: number | null;
  AccountId: number;
  AccountName?: string | null;
  CashboxId: number;
  CashboxName?: string | null;
  TotalAmount: number;
  Currency?: string | null;
  Description?: string | null;
  CreatedBy?: string | null;
  BranchId?: number | null;
  BranchName?: string | null; // ✅ YENİ: Kasa hareket raporu için şube adı
  IsRestaurantMode?: boolean;
  CashierId?: number | null;
  CashierName?: string | null;
  // Diğer ödeme spesifik alanlar
  OtherPaymentOptionId?: string | null;
  OtherPaymentLabel: string; // "Multinet", "Pluxee" vb.
  PaymentProviderType?: string | null;
  PaymentProviderId?: string | null;
  PaymentProviderName?: string | null;
  Items: QuickSaleCashWithInvoiceItem[];
}

/**
 * 🌐 ONLINE ÖDEME Hızlı Satış + Fatura Request DTO
 * Yemeksepeti, Getir, Trendyol vb. online platformlar için kullanılır
 * 3 ödeme yöntemi desteklenir: cash (nakit), pos (kredi kartı), online (platform ödemesi)
 */
export interface QuickSaleOnlinePaymentWithInvoiceRequest {
  IdempotencyKey?: string;
  DiscountType?: string | null;
  DiscountRate?: number | null;
  DiscountAmount?: number | null;
  CompanyName?: string | null;
  ScreenId?: number | null;
  AccountId: number;
  AccountName?: string | null;
  
  // Online Platform Bilgileri
  OnlinePlatform: string; // "YEMEK SEPETİ", "GETİR YEMEK" vb.
  PaymentMethod: 'cash' | 'pos' | 'online';
  
  // Kasa (Nakit veya Online için)
  CashboxId?: number | null;
  CashboxName?: string | null;
  
  // Banka (POS için)
  BankAccountId?: number | null;
  SubAccountId?: string | null;
  BankAccountName?: string | null;
  
  // Tutar
  TotalAmount: number;
  Currency?: string | null;
  Description?: string | null;
  
  // Diğer
  CreatedBy?: string | null;
  BranchId?: number | null;
  BranchName?: string | null; // ✅ YENİ: Kasa hareket raporu için şube adı
  IsRestaurantMode?: boolean;
  CashierId?: number | null;
  CashierName?: string | null;
  
  Items: QuickSaleOnlinePaymentItem[];
}

/**
 * 🌐 ONLINE ÖDEME Item DTO
 */
export interface QuickSaleOnlinePaymentItem {
  ProductId: string;
  ProductName?: string | null;
  StockCode?: string | null;
  WarehouseId: string;
  WarehouseName?: string | null;
  Quantity: number;
  Unit?: string | null;
  UnitPrice: number;
  VatRate?: number | null;
  SctRate?: number | null;
  PriceType?: string | null;
  HasRecipe?: boolean;
  HasMenu?: boolean;
  SelectedOptions?: OnlinePaymentSelectedOption[] | null;
  TotalPriceDifference?: number | null;
  // ✅ YENİ: İndirim kaydı (faturaya gerçek indirim yazmak için)
  OriginalPrice?: number | null;
  DiscountRate?: number;
  DiscountAmount?: number;
}

/**
 * 🌐 ONLINE ÖDEME Seçilen Opsiyon DTO
 */
export interface OnlinePaymentSelectedOption {
  ProductId: string;
  ProductName?: string | null;
  Quantity: number;
  IsOptional?: boolean;
  HasExtraOption?: boolean;
  ExtraOptionProductId?: string | null;
  ExtraOptionProductName?: string | null;
  PriceDifference?: number;
}

// ============================================
// 👤 KASİYER YÖNETİMİ TİPLERİ
// ============================================

/** Kasiyerin Cari Tahsilat'ta kullanabileceği kasa / banka hesabı. */
export interface CashierCollectionSource {
  SourceType: 'cashbox' | 'bank';
  SourceId: number;
  /** Yalnızca bank: alt hesap id'si; null = ana hesap. */
  SubAccountId: number | null;
}

export interface QuickSaleCashierDto {
  Id: number;
  ScreenType: 'QuickSale' | 'Restaurant' | 'Pyk';
  QuickSaleScreenId?: number | null;
  RestaurantScreenId?: number | null;
  PykScreenId?: number | null;
  CashierName: string;
  CashierPin: string;
  // Normal Hızlı Satış Yetkileri
  CanChangePrice: boolean;
  CanApplyDiscount: boolean;
  CanCancelSale: boolean;
  CanViewReports: boolean;
  CanViewEndOfDay: boolean;
  CanWarehouseOperations: boolean;
  CanViewAccountBalance: boolean;
  CanListAccounts: boolean;
  CanQuickAddItem: boolean;
  CanAddAccount: boolean;
  // Restoran Yetkileri
  CanCloseSale: boolean;
  CanCloseTable: boolean;
  CanAddProduct: boolean;
  CanRemoveProduct: boolean;
  CanClearCart: boolean;
  CanPrintToKitchen: boolean;
  CanDeletePrintedItems: boolean;
  CanDeleteUnprintedItems?: boolean; // Yazdırılmamış ürün silme yetkisi
  CanTransferTable: boolean;
  CanPosRefund: boolean;
  CanCancelReceipt?: boolean | null; // Adisyon iptal yetkisi
  CanCancelUnprintedReceipt?: boolean; // Yazdırılmamış adisyon iptal yetkisi
  CanPrintReceipt?: boolean | null; // Adisyon yazdırma yetkisi
  CanAddProductAfterReceiptPrint?: boolean; // Adisyon sonrası ürün ekleme
  CanUsePavoP2P?: boolean;
  CanCollectAccountPayment?: boolean; // YENİ: Cari tahsilat yetkisi
  // PYK Yetkileri
  CanPykLoadBalance?: boolean;
  CanPykRefundBalance?: boolean;
  CanPykManageSession?: boolean;
  // Durum
  IsActive: boolean;
  CreatedAt: string;
  UpdatedAt?: string | null;
}

export interface CreateQuickSaleCashierDto {
  ScreenType: 'QuickSale' | 'Restaurant' | 'Pyk';
  QuickSaleScreenId?: number | null;
  RestaurantScreenId?: number | null;
  PykScreenId?: number | null;
  CashierName: string;
  CashierPin: string;
  // Normal Hızlı Satış Yetkileri
  CanChangePrice?: boolean;
  CanApplyDiscount?: boolean;
  CanCancelSale?: boolean;
  CanViewReports?: boolean;
  CanViewEndOfDay?: boolean;
  CanWarehouseOperations?: boolean;
  CanViewAccountBalance?: boolean;
  CanListAccounts?: boolean;
  CanQuickAddItem?: boolean;
  CanAddAccount?: boolean;
  // Restoran Yetkileri
  CanCloseSale?: boolean;
  CanCloseTable?: boolean;
  CanAddProduct?: boolean;
  CanRemoveProduct?: boolean;
  CanClearCart?: boolean;
  CanPrintToKitchen?: boolean;
  CanDeletePrintedItems?: boolean;
  CanDeleteUnprintedItems?: boolean; // Yazdırılmamış ürün silme yetkisi
  CanTransferTable?: boolean;
  CanPosRefund?: boolean;
  CanCancelReceipt?: boolean; // Adisyon iptal yetkisi
  CanCancelUnprintedReceipt?: boolean; // Yazdırılmamış adisyon iptal yetkisi
  CanPrintReceipt?: boolean; // Adisyon yazdırma yetkisi
  CanAddProductAfterReceiptPrint?: boolean; // Adisyon sonrası ürün ekleme
  CanUsePavoP2P?: boolean;
  CanCollectAccountPayment?: boolean; // YENİ: Cari tahsilat yetkisi
  // PYK Yetkileri
  CanPykLoadBalance?: boolean;
  CanPykRefundBalance?: boolean;
  CanPykManageSession?: boolean;
  IsActive?: boolean;
}

export interface UpdateQuickSaleCashierDto {
  Id: number;
  CashierName?: string;
  CashierPin?: string;
  // Normal Hızlı Satış Yetkileri
  CanChangePrice?: boolean;
  CanApplyDiscount?: boolean;
  CanCancelSale?: boolean;
  CanViewReports?: boolean;
  CanViewEndOfDay?: boolean;
  CanWarehouseOperations?: boolean;
  CanViewAccountBalance?: boolean;
  CanListAccounts?: boolean;
  CanQuickAddItem?: boolean;
  CanAddAccount?: boolean;
  // Restoran Yetkileri
  CanCloseSale?: boolean;
  CanCloseTable?: boolean;
  CanAddProduct?: boolean;
  CanRemoveProduct?: boolean;
  CanClearCart?: boolean;
  CanPrintToKitchen?: boolean;
  CanDeletePrintedItems?: boolean;
  CanDeleteUnprintedItems?: boolean; // Yazdırılmamış ürün silme yetkisi
  CanTransferTable?: boolean;
  CanPosRefund?: boolean;
  CanCancelReceipt?: boolean; // Adisyon iptal yetkisi
  CanCancelUnprintedReceipt?: boolean; // Yazdırılmamış adisyon iptal yetkisi
  CanPrintReceipt?: boolean; // Adisyon yazdırma yetkisi
  CanAddProductAfterReceiptPrint?: boolean; // Adisyon sonrası ürün ekleme
  CanUsePavoP2P?: boolean;
  CanCollectAccountPayment?: boolean; // YENİ: Cari tahsilat yetkisi
  // PYK Yetkileri
  CanPykLoadBalance?: boolean;
  CanPykRefundBalance?: boolean;
  CanPykManageSession?: boolean;
  IsActive?: boolean;
}

export interface ValidateCashierPinDto {
  ScreenType: 'QuickSale' | 'Restaurant' | 'Pyk' | 'WmsPicking' | 'WmsPacking' | 'WmsReceiving' | 'WmsCycleCount';
  QuickSaleScreenId?: number | null;
  RestaurantScreenId?: number | null;
  PykScreenId?: number | null;
  WmsPickingScreenId?: string | null;
  WmsPackingScreenId?: string | null;
  WmsReceivingScreenId?: string | null;
  WmsCycleCountScreenId?: string | null;
  Pin: string;
}

export interface ValidateCashierResponseDto {
  IsValid: boolean;
  CashierId?: number | null;
  CashierName?: string | null;
  Message?: string | null;
  // Normal Hızlı Satış Yetkileri
  CanChangePrice?: boolean | null;
  CanApplyDiscount?: boolean | null;
  CanCancelSale?: boolean | null;
  CanViewReports?: boolean | null;
  CanViewEndOfDay?: boolean | null;
  CanWarehouseOperations?: boolean | null;
  CanViewAccountBalance?: boolean | null;
  CanListAccounts?: boolean | null;
  CanQuickAddItem?: boolean | null;
  CanAddAccount?: boolean | null;
  // Restoran Yetkileri
  CanCloseSale?: boolean | null;
  CanCloseTable?: boolean | null;
  CanAddProduct?: boolean | null;
  CanRemoveProduct?: boolean | null;
  CanClearCart?: boolean | null;
  CanPrintToKitchen?: boolean | null;
  CanDeletePrintedItems?: boolean | null;
  CanDeleteUnprintedItems?: boolean | null; // Yazdırılmamış ürün silme yetkisi
  CanTransferTable?: boolean | null;
  CanPosRefund?: boolean | null;
  CanCancelReceipt?: boolean | null;
  CanCancelUnprintedReceipt?: boolean | null; // Yazdırılmamış adisyon iptal yetkisi
  CanPrintReceipt?: boolean | null;
  CanAddProductAfterReceiptPrint?: boolean | null;
  CanUsePavoP2P?: boolean | null;
  CanCollectAccountPayment?: boolean | null; // YENİ: Cari tahsilat yetkisi
  // WMS Yetkileri
  CanWmsPicking?: boolean | null;
  CanWmsPacking?: boolean | null;
  CanWmsReceiving?: boolean | null;
  CanWmsCycleCount?: boolean | null;
  WmsPickingScreenId?: string | null;
  WmsPackingScreenId?: string | null;
  WmsReceivingScreenId?: string | null;
  WmsCycleCountScreenId?: string | null;
  // PYK Yetkileri
  CanPykLoadBalance?: boolean | null;
  CanPykRefundBalance?: boolean | null;
  CanPykManageSession?: boolean | null;
}

// ============================================
// ÜRÜN SATIŞ ÖZETİ (GÜN SONU RAPORU İÇİN)
// ============================================

export interface ProductSalesSummaryItem {
  ProductName: string;
  UnitPrice: number;
  TotalQuantity: number;
  TotalAmount: number;
}

export interface ProductSalesSummaryResponse {
  Success: boolean;
  Message?: string;
  Items: ProductSalesSummaryItem[];
  GrandTotal: number;
  TotalProductCount: number;
}

// Singleton instance
const salesService = new SalesService();
export default salesService;

// ============================================
// ÜRÜN SATIŞ ÖZETİ API ÇAĞRISI
// ============================================

export async function getProductSalesSummary(
  startDate: string,
  endDate: string,
  branchId?: string | null
): Promise<ProductSalesSummaryResponse> {
  try {
    const params = new URLSearchParams({
      startDate,
      endDate,
    });
    
    if (branchId) {
      params.append('branchId', branchId);
    }
    
    console.log('[salesService] 📊 getProductSalesSummary çağrıldı:', { startDate, endDate, branchId });
    
    const response = await salesApi.get<ProductSalesSummaryResponse>(
      `/api/QuickSaleWithInvoice/product-sales-summary?${params.toString()}`
    );
    
    console.log('[salesService] ✅ getProductSalesSummary yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getProductSalesSummary HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Ürün satış özeti alınamadı',
      Items: [],
      GrandTotal: 0,
      TotalProductCount: 0
    };
  }
}

// ════════════════════════════════════════════════════════════════════════════════
// MÜŞTERİ EKRANI (CUSTOMER DISPLAY) API
// POS cihazlarındaki ikinci ekran için reklam ve sepet görüntüleme sistemi
// ════════════════════════════════════════════════════════════════════════════════

export interface CustomerDisplaySettingsDto {
  Id: number;
  QuickSaleScreenId: number;
  IsEnabled: boolean;
  AnimationType: string;
  SlideInterval: number;
  ShowCartOnActivity: boolean;
  CartDisplayDuration: number;
  CartBackgroundColor?: string | null;
  CartTextColor?: string | null;
  CartTotalFontSize?: number | null;
  CartSideImageUrl?: string | null; // ✅ YENİ: Sepet yan panel resmi
  CreatedAt: string;
  UpdatedAt?: string | null;
  Images: CustomerDisplayImageDto[];
}

export interface CustomerDisplayImageDto {
  Id: number;
  CustomerDisplaySettingsId: number;
  ImageUrl: string;
  ImageTitle?: string | null;
  DisplayOrder: number;
  IsActive: boolean;
  CreatedAt: string;
  UpdatedAt?: string | null;
}

export interface SaveCustomerDisplaySettingsDto {
  QuickSaleScreenId: number;
  IsEnabled: boolean;
  AnimationType: string;
  SlideInterval: number;
  ShowCartOnActivity: boolean;
  CartDisplayDuration: number;
  CartBackgroundColor?: string | null;
  CartTextColor?: string | null;
  CartTotalFontSize?: number | null;
  CartSideImageUrl?: string | null; // ✅ YENİ: Sepet yan panel resmi
}

export interface AddCustomerDisplayImageDto {
  CustomerDisplaySettingsId: number;
  ImageUrl: string;
  ImageTitle?: string | null;
  DisplayOrder?: number;
}

/**
 * Müşteri ekranı ayarlarını getir
 */
export async function getCustomerDisplaySettings(
  screenId: number
): Promise<{ Success: boolean; Data: CustomerDisplaySettingsDto | null; Message?: string }> {
  try {
    console.log('[salesService] 📺 getCustomerDisplaySettings çağrıldı:', { screenId });
    
    const response = await salesApi.get(
      `/api/CustomerDisplay/settings/${screenId}`
    );
    
    console.log('[salesService] ✅ getCustomerDisplaySettings yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getCustomerDisplaySettings HATA:', error);
    return {
      Success: false,
      Data: null,
      Message: error.response?.data?.Message || error.message || 'Müşteri ekranı ayarları alınamadı'
    };
  }
}

/**
 * Müşteri ekranı ayarlarını kaydet (Create veya Update)
 */
export async function saveCustomerDisplaySettings(
  dto: SaveCustomerDisplaySettingsDto
): Promise<{ Success: boolean; Data: CustomerDisplaySettingsDto | null; Message?: string }> {
  try {
    console.log('[salesService] 💾 saveCustomerDisplaySettings çağrıldı:', dto);
    
    const response = await salesApi.post(
      `/api/CustomerDisplay/settings`,
      dto
    );
    
    console.log('[salesService] ✅ saveCustomerDisplaySettings yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ saveCustomerDisplaySettings HATA:', error);
    return {
      Success: false,
      Data: null,
      Message: error.response?.data?.Message || error.message || 'Müşteri ekranı ayarları kaydedilemedi'
    };
  }
}

/**
 * Müşteri ekranı resimlerini getir
 */
export async function getCustomerDisplayImages(
  settingsId: number
): Promise<{ Success: boolean; Data: CustomerDisplayImageDto[]; Count: number; Message?: string }> {
  try {
    console.log('[salesService] 🖼️ getCustomerDisplayImages çağrıldı:', { settingsId });
    
    const response = await salesApi.get(
      `/api/CustomerDisplay/images/${settingsId}`
    );
    
    console.log('[salesService] ✅ getCustomerDisplayImages yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getCustomerDisplayImages HATA:', error);
    return {
      Success: false,
      Data: [],
      Count: 0,
      Message: error.response?.data?.Message || error.message || 'Müşteri ekranı resimleri alınamadı'
    };
  }
}

/**
 * Müşteri ekranına yeni resim ekle
 */
export async function addCustomerDisplayImage(
  dto: AddCustomerDisplayImageDto
): Promise<{ Success: boolean; Data: CustomerDisplayImageDto | null; Message?: string }> {
  try {
    console.log('[salesService] ➕ addCustomerDisplayImage çağrıldı:', dto);
    
    const response = await salesApi.post(
      `/api/CustomerDisplay/images`,
      dto
    );
    
    console.log('[salesService] ✅ addCustomerDisplayImage yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ addCustomerDisplayImage HATA:', error);
    return {
      Success: false,
      Data: null,
      Message: error.response?.data?.Message || error.message || 'Resim eklenemedi'
    };
  }
}

/**
 * Müşteri ekranı resim sıralamasını güncelle
 */
export async function reorderCustomerDisplayImages(
  items: { Id: number; DisplayOrder: number }[]
): Promise<{ Success: boolean; Message?: string }> {
  try {
    console.log('[salesService] 🔄 reorderCustomerDisplayImages çağrıldı:', { items });
    
    const response = await salesApi.post(
      `/api/CustomerDisplay/images/reorder`,
      { Items: items }
    );
    
    console.log('[salesService] ✅ reorderCustomerDisplayImages yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ reorderCustomerDisplayImages HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Resim sıralaması güncellenemedi'
    };
  }
}

/**
 * Müşteri ekranı resmini sil
 */
export async function deleteCustomerDisplayImage(
  id: number
): Promise<{ Success: boolean; Message?: string }> {
  try {
    console.log('[salesService] 🗑️ deleteCustomerDisplayImage çağrıldı:', { id });
    
    const response = await salesApi.post(
      `/api/CustomerDisplay/images/delete`,
      { Id: id }
    );
    
    console.log('[salesService] ✅ deleteCustomerDisplayImage yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ deleteCustomerDisplayImage HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Resim silinemedi'
    };
  }
}

// ============================================
// PACKAGE ORDER FUNCTIONS (Paket Sipariş Yönetimi)
// ============================================

export interface CreatePackageOrderItemDto {
  ProductId?: string;
  ProductCode?: string;
  ProductName: string;
  ProductBarcode?: string;
  CategoryId?: number;
  CategoryName?: string;
  Quantity: number;
  UnitId?: number;
  UnitName?: string;
  UnitPrice: number;
  DiscountRate?: number;
  DiscountAmount?: number;
  TaxRate?: number;
  TaxAmount?: number;
  SubTotal: number;
  TotalAmount: number;
  Notes?: string;
  // ✅ YENİ: Reçete/Menü ve Depo bilgileri (stok düşümü için)
  HasRecipe?: boolean;
  HasMenu?: boolean;
  // ✅ YENİ: KDV Dahil/Hariç bilgisi (Fatura hesaplaması için)
  // VAT_INCLUDED = KDV Dahil, VAT_EXCLUDED = KDV Hariç
  PriceType?: string;
  WarehouseId?: string;
  WarehouseName?: string;
}

export interface CreatePackageOrderDto {
  BranchId?: string;
  AccountId: number;
  AccountName?: string;
  CustomerPhone?: string;
  CustomerAddressId?: number;
  CustomerAddress?: string;
  CustomerNotes?: string;
  SubTotal: number;
  DiscountAmount?: number;
  TaxAmount?: number;
  TotalAmount: number;
  Notes?: string;
  CreatedBy?: string;
  CreatedByName?: string;
  CashierId?: number;  // Kasiyer ID
  CashierName?: string;  // Kasiyer adı
  PaymentMethod?: string;  // Ödeme yöntemi (CASH, POS, ONLINE)
  Items: CreatePackageOrderItemDto[];
}

export interface PackageOrderItemDto {
  Id: number;
  ProductId?: string;
  ProductCode?: string;
  ProductName?: string;
  ProductBarcode?: string;
  CategoryName?: string;
  Quantity: number;
  UnitName?: string;
  UnitPrice: number;
  DiscountAmount?: number;
  TaxRate?: number;
  TaxAmount?: number;
  SubTotal: number;
  TotalAmount: number;
  Notes?: string;
  ItemStatus?: string;
  // ✅ YENİ: Reçete/Menü ve Depo bilgileri
  HasRecipe?: boolean;
  HasMenu?: boolean;
  WarehouseId?: string;
  WarehouseName?: string;
  // ✅ YENİ: KDV Dahil/Hariç bilgisi (Fatura hesaplaması için)
  PriceType?: string;
}

export interface PackageOrderDto {
  Id: number;
  OrderNumber?: string;
  ShortCode?: string;
  AccountId: number;
  AccountName?: string;
  CustomerPhone?: string;
  CustomerAddress?: string;
  /**
   * Telefon paket fişlerinde detaylı adres satırını oluşturmak için backend
   * tarafında AccountShippingAddress join'iyle dolduruluyor. Müşterinin
   * kayıtlı adres detayları yoksa undefined kalır.
   */
  Mahalle?: string;
  Cadde?: string;
  Sokak?: string;
  Apartman?: string;
  SiteAdi?: string;
  Blok?: string;
  BinaNo?: string;
  Kat?: string;
  DaireNo?: string;
  CustomerNotes?: string;
  SubTotal: number;
  DiscountAmount?: number;
  TaxAmount?: number;
  TotalAmount: number;
  OrderStatus?: string;
  /** Bazı proxy/client katmanları camelCase döndürebilir */
  orderStatus?: string;
  PaymentStatus?: string;
  PaymentMethod?: string;
  TotalPaid?: number;
  RemainingAmount?: number;
  CourierId?: string;
  CourierName?: string;
  CourierPhone?: string;
  CourierStatus?: string; // assigned, accepted, picked_up, delivered
  EstimatedDeliveryTime?: string;
  ActualDeliveryTime?: string;
  DeliveryDurationMinutes?: number;
  Notes?: string;
  CreatedAt: string;
  CreatedByName?: string;
  CompletedAt?: string;
  CancelledAt?: string;
  CancelReason?: string;
  CancelNote?: string;
  WaitingMinutes?: number;
  ItemCount?: number;
  InvoiceId?: string | null;
  InvoiceNumber?: string | null;
  ReferenceNumber?: string | null;
  Items?: PackageOrderItemDto[];
  // Backend PackageOrderDto.MapToDto bu alanları zaten döndürüyor; gün sonu
  // raporu (EndOfDayReport) iptal edilmiş telefon siparişlerini şube/source
  // bazlı filtrelemek için kullanır.
  BranchId?: string | null;
  SyncSource?: string | null; // örn: "phone", "yemeksepeti", "getir" ...
}

export interface PackageOrderResultDto {
  Success: boolean;
  OrderId?: number;
  OrderNumber?: string;
  ShortCode?: string;
  Message?: string;
  /**
   * `addItemsToPackageOrder` çağrılarında **yeni** eklenen item ID'leri.
   * Mutfak fişine sadece bu kalemler basılır (delta print).
   * Yeni sipariş oluşturma akışında undefined kalır.
   */
  AddedItemIds?: number[];
}

/**
 * Yeni paket siparişi oluştur
 */
export async function createPackageOrder(
  dto: CreatePackageOrderDto
): Promise<PackageOrderResultDto> {
  try {
    console.log('[salesService] 📦 createPackageOrder çağrıldı:', dto);
    
    const response = await salesApi.post(
      `/api/PackageOrder/create`,
      dto
    );
    
    console.log('[salesService] ✅ createPackageOrder yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ createPackageOrder HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Sipariş oluşturulamadı'
    };
  }
}

/**
 * Bugünkü siparişleri getir
 */
export async function getTodayPackageOrders(
  branchId?: string
): Promise<{ Success: boolean; Data?: PackageOrderDto[]; Count?: number; Message?: string }> {
  try {
    console.log('[salesService] 📦 getTodayPackageOrders çağrıldı:', { branchId });
    
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId);
    const queryStr = params.toString();
    
    const response = await salesApi.get(
      `/api/PackageOrder/today${queryStr ? '?' + queryStr : ''}`
    );
    
    console.log('[salesService] ✅ getTodayPackageOrders yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getTodayPackageOrders HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Siparişler getirilemedi'
    };
  }
}

/**
 * Aktif siparişleri getir (tamamlanmamış)
 */
export async function getActivePackageOrders(
  branchId?: string
): Promise<{ Success: boolean; Data?: PackageOrderDto[]; Count?: number; Message?: string }> {
  try {
    console.log('[salesService] 📦 getActivePackageOrders çağrıldı:', { branchId });
    
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId);
    const queryStr = params.toString();
    
    const response = await salesApi.get(
      `/api/PackageOrder/active${queryStr ? '?' + queryStr : ''}`
    );
    
    console.log('[salesService] ✅ getActivePackageOrders yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getActivePackageOrders HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Aktif siparişler getirilemedi'
    };
  }
}

/**
 * Tarih aralığına göre siparişleri getir (Gün sonu raporu için)
 */
export async function getPackageOrdersByDateRange(
  startDate?: Date,
  endDate?: Date,
  branchId?: string
): Promise<{ Success: boolean; Data?: PackageOrderDto[]; Count?: number; Message?: string }> {
  try {
    console.log('[salesService] 📦 getPackageOrdersByDateRange çağrıldı:', { startDate, endDate, branchId });

    // Backend `PackageOrderManager` `.Date` kullandığı için Z'siz local-format
    // gönderiyoruz. Aksi halde Türkiye saati 11 May 00:00 → UTC 10 May 21:00 →
    // `.Date` = 10 May → off-by-one (dünün siparişleri de gelir).
    const fmt = (d: Date): string => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const mm = String(d.getMinutes()).padStart(2, '0');
      const ss = String(d.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${day}T${hh}:${mm}:${ss}`;
    };
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', fmt(startDate));
    if (endDate) params.append('endDate', fmt(endDate));
    if (branchId) params.append('branchId', branchId);
    
    const response = await salesApi.get(
      `/api/PackageOrder/by-date-range?${params.toString()}`
    );
    
    console.log('[salesService] ✅ getPackageOrdersByDateRange yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getPackageOrdersByDateRange HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Siparişler getirilemedi'
    };
  }
}

/**
 * Tek bir siparişi getir
 */
export async function getPackageOrderById(
  id: number
): Promise<{ Success: boolean; Data?: PackageOrderDto; Message?: string }> {
  try {
    console.log('[salesService] 📦 getPackageOrderById çağrıldı:', { id });
    
    const response = await salesApi.get(
      `/api/PackageOrder/${id}`
    );
    
    console.log('[salesService] ✅ getPackageOrderById yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ getPackageOrderById HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Sipariş getirilemedi'
    };
  }
}

/**
 * Sipariş durumunu güncelle
 */
export async function updatePackageOrderStatus(
  orderId: number,
  newStatus: string,
  updatedBy?: string,
  courierFirebaseUid?: string,
  courierName?: string
): Promise<{ Success: boolean; Message?: string }> {
  try {
    console.log('[salesService] 📦 updatePackageOrderStatus çağrıldı:', { orderId, newStatus, courierFirebaseUid, courierName });
    
    const response = await salesApi.post(
      `/api/PackageOrder/update-status`,
      { 
        OrderId: orderId, 
        NewStatus: newStatus, 
        UpdatedBy: updatedBy,
        CourierFirebaseUid: courierFirebaseUid,
        CourierName: courierName
      }
    );
    
    console.log('[salesService] ✅ updatePackageOrderStatus yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ updatePackageOrderStatus HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Sipariş durumu güncellenemedi'
    };
  }
}

/**
 * Siparişi iptal et.
 * Plan PR1: cancelNote opsiyonel — UI'da "Diğer" sebebi seçildiğinde zorunlu olarak doldurulmalı.
 */
export async function cancelPackageOrder(
  orderId: number,
  cancelReason: string,
  cancelNote?: string,
  cancelledBy?: string,
  cancelledByName?: string
): Promise<{ Success: boolean; Message?: string }> {
  try {
    console.log('[salesService] 📦 cancelPackageOrder çağrıldı:', { orderId, cancelReason, cancelNote });

    const response = await salesApi.post(
      `/api/PackageOrder/cancel`,
      {
        OrderId: orderId,
        CancelReason: cancelReason,
        CancelNote: cancelNote,
        CancelledBy: cancelledBy,
        CancelledByName: cancelledByName
      }
    );

    console.log('[salesService] ✅ cancelPackageOrder yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ cancelPackageOrder HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Sipariş iptal edilemedi'
    };
  }
}

/**
 * Kurye ata
 */
export async function assignCourierToPackageOrder(
  orderId: number,
  courierId: string,
  courierName: string,
  courierPhone?: string
): Promise<{ Success: boolean; Message?: string }> {
  try {
    console.log('[salesService] 📦 assignCourierToPackageOrder çağrıldı:', { orderId, courierName });
    
    const response = await salesApi.post(
      `/api/PackageOrder/assign-courier`,
      { 
        OrderId: orderId, 
        CourierId: courierId, 
        CourierName: courierName, 
        CourierPhone: courierPhone 
      }
    );
    
    console.log('[salesService] ✅ assignCourierToPackageOrder yanıtı:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ assignCourierToPackageOrder HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Kurye atanamadı'
    };
  }
}

/**
 * Mevcut siparişe ilave ürün ekle (İlave Sipariş)
 */
export async function addItemsToPackageOrder(
  orderId: number,
  items: CreatePackageOrderItemDto[],
  updatedBy?: string,
  updatedByName?: string
): Promise<PackageOrderResultDto> {
  try {
    const payload = { 
      Items: items,
      UpdatedBy: updatedBy,
      UpdatedByName: updatedByName
    };
    console.log('[salesService] 📦 addItemsToPackageOrder çağrıldı:', { 
      orderId, 
      itemCount: items.length,
      items: items.map(i => ({ name: i.ProductName, qty: i.Quantity, price: i.UnitPrice, total: i.TotalAmount })),
      payload: JSON.stringify(payload).substring(0, 500)
    });
    
    const response = await salesApi.post(
      `/api/PackageOrder/${orderId}/add-items`,
      payload
    );
    
    console.log('[salesService] ✅ addItemsToPackageOrder yanıtı:', JSON.stringify(response.data));
    return response.data;
  } catch (error: any) {
    console.error('[salesService] ❌ addItemsToPackageOrder HATA:', error);
    return {
      Success: false,
      Message: error.response?.data?.Message || error.message || 'Ürünler eklenemedi'
    };
  }
}

// ============================================================================
// PR2: Telefon Siparişi Sepet Düzenleme — kalem sil & güncelle
// ============================================================================
// Backend: POST /api/PackageOrder/{orderId}/{remove-item|update-item}
// Yanıt: { Success: boolean; Order?: PackageOrderDto; Message?: string }
//
// Hata kodları (HTTP status doğrudan backend'den gelir, axios .response.status):
//   400 → validation (status/kurye/ödeme/Pavo guard veya quantity)
//   403 → multi-tenant (companyId mismatch)
//   404 → sipariş veya kalem yok
//   500 → beklenmedik
//
// İki metod da hata olduğunda `throw` eder; UI try/catch ile yakalayıp
// optimistic state'i rollback eder + Snackbar gösterir.
// ============================================================================

export interface EditCartResultDto {
  Success: boolean;
  Order?: PackageOrderDto;
  Message?: string;
}

/**
 * Sipariş kalemini kaldırır (backend'de soft-delete; audit korunur).
 * Başarılıysa güncel `PackageOrderDto` döner.
 * Başarısızlıkta `Error(message)` fırlatır.
 */
export async function removePackageOrderItem(
  orderId: number,
  itemId: number,
  updatedBy?: string,
  updatedByName?: string
): Promise<PackageOrderDto> {
  try {
    console.log('[salesService] 📦 removePackageOrderItem çağrıldı:', { orderId, itemId });
    const response = await salesApi.post<EditCartResultDto>(
      `/api/PackageOrder/${orderId}/remove-item`,
      { ItemId: itemId, UpdatedBy: updatedBy, UpdatedByName: updatedByName }
    );
    if (!response.data.Success || !response.data.Order) {
      throw new Error(response.data.Message || 'Kalem silinemedi.');
    }
    console.log('[salesService] ✅ removePackageOrderItem yanıtı:', { newTotal: response.data.Order.TotalAmount });
    return response.data.Order;
  } catch (error: any) {
    const msg = error?.response?.data?.Message || error?.message || 'Kalem silinemedi';
    console.error('[salesService] ❌ removePackageOrderItem HATA:', { orderId, itemId, msg });
    throw new Error(msg);
  }
}

/**
 * Sipariş kalemini kısmi günceller (Rule 5: yalnızca verilen alanlar).
 * Patch alanları:
 *  - quantity?: number  (> 0; backend 400 döner aksi halde)
 *  - note?: string      ("" → notu temizle; undefined → değişmez)
 *  - price?: number     (admin için; UI'da bu plan kapsamında salt-okunur)
 *
 * Başarılıysa güncel `PackageOrderDto` döner; aksi halde `Error` fırlatır.
 */
export async function updatePackageOrderItem(
  orderId: number,
  itemId: number,
  patch: { quantity?: number; note?: string; price?: number },
  updatedBy?: string,
  updatedByName?: string
): Promise<PackageOrderDto> {
  try {
    console.log('[salesService] 📦 updatePackageOrderItem çağrıldı:', { orderId, itemId, patch });
    const response = await salesApi.post<EditCartResultDto>(
      `/api/PackageOrder/${orderId}/update-item`,
      {
        ItemId: itemId,
        Quantity: patch.quantity,
        Note: patch.note,
        Price: patch.price,
        UpdatedBy: updatedBy,
        UpdatedByName: updatedByName,
      }
    );
    if (!response.data.Success || !response.data.Order) {
      throw new Error(response.data.Message || 'Kalem güncellenemedi.');
    }
    console.log('[salesService] ✅ updatePackageOrderItem yanıtı:', { newTotal: response.data.Order.TotalAmount });
    return response.data.Order;
  } catch (error: any) {
    const msg = error?.response?.data?.Message || error?.message || 'Kalem güncellenemedi';
    console.error('[salesService] ❌ updatePackageOrderItem HATA:', { orderId, itemId, msg });
    throw new Error(msg);
  }
}
